import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { CierreService } from 'app/main/wizard-cgo/services/cierre.service';
import { lang_conteos } from 'app/idiomas/i18n/Conteos/conteos.lang';
import { lang_toolbar } from 'app/idiomas/i18n/toolbar/toolbar.lang';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
// //SERVICE
import { CloseService as cierreCertificar } from "app/main/pagina/certificar/services/cierre.service";
import { CloseService as cierreMedir } from "app/main/pagina/medir/services/cierre.service";
import { CloseService as cierrePulse } from "app/main/pagina/pulse/services/cierre.service";
import { CloseService as cierreFocus } from "app/main/pagina/FocusA/services/cierre.service";
import { ConteosService } from 'app/main/wizard-cgo/services/conteos.service';
import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import { Cierren35Service } from 'app/main/wizard-n35encuestador/services/cierren35.service';
import * as backInter from 'app/auth/auth-data.model';
import * as backClose from 'app/main/pagina/encuestador-n35/close35/close35.interface';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { WizardService as wizardService  } from 'app/main/wizard-cgo/services/wizard.service';
import {FormControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
////graficas
import {ViewChild } from '@angular/core';
import { ChartDataSets, ChartOptions,ChartType } from 'chart.js';
import { Color, BaseChartDirective, Label } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import Swal from 'sweetalert2';
import { AuthService } from 'app/auth/auth.service';
import {SurveyService} from './survey.service';
import { DATOS_API } from 'app/auth/auth.datos';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import { lang_avances } from 'app/idiomas/i18n/avances/avances.lang';
import { MatTabChangeEvent } from '@angular/material/tabs';
const moment = require('moment');
const momentTz = require('moment-timezone');
import *  as $ from 'jquery';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DatePipe } from '@angular/common';
import { zonasUTC } from 'app/main/pagina/zonasUtc';
export interface DialogData {
  SurveyId:any,
  surveyKey:any,
  idEmpresa:any,
  idProducto:any
}
export interface resultado{
  email: string,
  fullName: string,
  surveyKey: string,
  _id: string,
  estado?:string,
}

export interface filtrosPortalConteosV2{
  COLABORADORES_QUE_AUN_NO_RESPONDEN: number,
  COLABORADORES_QUE_YA_RESPONDIERON: number,
  FILTRO: string,
  Nivel_1: string,
  Nivel_2: string,
  PROGRESO_TOTAL: number,
  SEGMENTO: string,
  TOTAL_DE_COLABORADORES: number
}

export interface filtrosPortalConteosV2Reducido{
  COLABORADORES_QUE_AUN_NO_RESPONDEN: number,
  COLABORADORES_QUE_YA_RESPONDIERON: number,
  FILTRO: string,
  PROGRESO_TOTAL: number,
  SEGMENTO: string,
  TOTAL_DE_COLABORADORES: number
}


@Component({
  selector: 'app-portal-conteos',
  templateUrl: './portal-conteos.component.html',
  styleUrls: ['./portal-conteos.component.scss']
})
export class PortalConteosComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns: string[] = ['nivel1', 'nivel2','demografico', 'segmento', 'colaboradoresTotales', 'pendientesResponder', 'respondieron', 'avance'];
  filtroPortalv2: MatTableDataSource<backInter.filtrosPortalConteosV2>;
  datosTablaFiltro:backInter.filtrosPortalConteosV2;

  displayedColumnsReducido: string[] = ['demografico', 'segmento', 'colaboradoresTotales', 'pendientesResponder', 'respondieron', 'avance'];
  filtroPortalv2Reducido: MatTableDataSource<backInter.filtrosPortalConteosV2Reducido>;
  datosTablaFiltroReducido:backInter.filtrosPortalConteosV2Reducido;

  datosEncontrados: boolean;
  bubbleChartOptions: ChartOptions;
  // lineChartOptions: ChartOptions;

  public bubbleChartType: ChartType = 'bubble';
  public bubbleChartLegend = true;
  public bubbleChartData: ChartDataSets[] = [

    {
      data: [
        { x: 10, y: 10, r: 6 },
        { x: 15, y: 5, r: 6 },
        { x: 26, y: 12, r: 6 },
        { x: 7, y: 8, r: 6 },
      ],
      label: '',
      backgroundColor: 'green',
      borderColor: 'blue',
      hoverBackgroundColor: 'purple',
      hoverBorderColor: 'red',
      pointStyle:'circle',
    },
  ];

  public bubbleChartColors: Color[] = [
    {
      backgroundColor: [

        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',
        '#2E86C1',


      ]
    }
  ];

// graficaLineal
public lineChartType: ChartType = 'line';
public lineChartLegend  = true;
public lineChartLabels: any[] = ['12/08/2021', '12/09/2021', '12/10/2021', '12/11/2021', '12/12/2021', '12/08/2021', '12/13/2021', '12/14/2021', '12/15/2021'];
lineChartOptions: ChartOptions;
public lineChartData: ChartDataSets[] = [
  {
  data: [65, 59, 80, 81, 56, 55, 40],
    label: '',
    // // backgroundColor: '#2E86C1',
    // borderColor: '#2E86C1',
    // hoverBackgroundColor: '#2E86C1',
    // // hoverBorderColor: 'red',
    // pointStyle:'circle',
    // pointRadius: 10,
    // backgroundColor: 'transparent',
    // lineTension: 0,
    // fill: false,
    lineTension: 0,
    fill: false,
    borderColor: 'orange',
    backgroundColor: 'transparent',
    borderDash: [5, 5],
    pointBorderColor: 'orange',
    pointBackgroundColor: 'rgba(255,150,0,0.5)',
    pointRadius: 10,
    pointHoverRadius: 15,
    pointHitRadius: 30,
    pointBorderWidth: 2,
    pointStyle: 'rectRounded'
  },
];

public lineChartColors: Color[] = [
  {
    // backgroundColor: ['#2E86C1',
    //   ]
  }
];


  idiomaActual:string;
  cargando = true;
  infoAvanceConteo: backInter.portalConteos;
  filtrosInfoFullExcel: backInter.getFullInfoExcel;
  statusNorma:boolean=false;
  tipoProducto: string;
  urlProducto: string;
  listaFiltros: backInter.listaFiltros[] = [];
  resultadoConteo: backInter.getConteosFiltros;
  timeLineGraficaCer: backInter.timeLineGraficaCertificar;


  nombre:string;
  idFiltro: number;
  styleElement: HTMLStyleElement;
  info:any;
  banderaencuesta35:any;


  centrosTrabajo: any[]=[];
  centrosTrabajoTmp: any[]=[];
  dataCT:any [] = [];
  estatusCT: boolean = true;
  nombreCT:any;
  idCt:any;
  selectType:boolean = true;
  uncomplete_users:any;
  uncompleteUsers:any;
  sumaFormula1: number;
  sumaFormula2:number;
  resultadoRanking: number;
  resultadoEntregables: number;
  fechaLanzamiento: string;
  fechaCierre: string;
  diasRestantes: number;
  diasTranscurridos: number;
  progreso: number;
  resultGetProrrogasFechaCierre:any;

  fxFlexEspacio=20;
  validacionNorma35=0;
  nombre35:string;
  cargandoFiltros:boolean=false;
  url:string;
  instituto:any;
  FiltroCT:boolean=false;
  fechaAnterior:boolean =false;
  valorMayor: number;
  totalUsers:any;
  respRecRes:any;
  respMinCer:any;
  endUsers:any;
  porcentajeUsers:any;
  tmp:any;
  tmp2:any;
  tipoEncuesta:any;
  mensaje=false;


  mensajesTraducirKeys: string[] = [
    'CERTIFICAR.COLABORADORES.MENSAJES.GUARDA_1',
    'CERTIFICAR.COLABORADORES.MENSAJES.GUARDA_2',
    'CERTIFICAR.COLABORADORES.MENSAJES.GUARDADO',
    'CERTIFICAR.COLABORADORES.MENSAJES.GUA_ERR',
    'CERTIFICAR.COLABORADORES.MENSAJES.DELETE_1',
    'CERTIFICAR.COLABORADORES.MENSAJES.DELETE_2',
    'CERTIFICAR.COLABORADORES.MENSAJES.DEL_OK_1',
    'CERTIFICAR.COLABORADORES.MENSAJES.DEL_OK_2',
    'CERTIFICAR.COLABORADORES.MENSAJES.DEL_ERR',
    'CERTIFICAR.COLABORADORES.MENSAJES.DELFILE',
    'CERTIFICAR.COLABORADORES.MENSAJES.EXCEL',
    'CERTIFICAR.COLABORADORES.MENSAJES.EXTMAL',
    'CERTIFICAR.COLABORADORES.MENSAJES.NOROWS',
    'CERTIFICAR.COLABORADORES.MENSAJES.VACIO',
    'CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.SI',
    'CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.NO',
    'CERTIFICAR.COLABORADORES.EXCELINFO.HOJA',
    'CERTIFICAR.COLABORADORES.EXCELINFO.TITULO',
    'CERTIFICAR.COLABORADORES.EXCELINFO.AUTOR',
    'CERTIFICAR.COLABORADORES.EXCELINFO.ASUNTO',
    'CERTIFICAR.IDIOMAS.MENSAJES.ERRORDEL',
    'PORTAL.EXCEL.NOMEMPRE',
    'PORTAL.EXCEL.NOMUSUARIO',
    'PORTAL.EXCEL.NOMPROD',
    'PORTAL.EXCEL.FECHLANZA',
    'PORTAL.EXCEL.FECHDESCA',
    'PORTAL.EXCEL.DRESTAN',
    'PORTAL.EXCEL.TOTALCOLA',
    'PORTAL.EXCEL.TOTALFAL',
    'PORTAL.EXCEL.TOTALCONT',
    'PORTAL.EXCEL.TOTALPRO',
    'PORTAL.EXCEL.REPORTE',
    'PORTAL.EXCEL.FILT',
    'PORTAL.EXCEL.RANKING',
    'PORTAL.EXCEL.NOMFILT',
    'PORTAL.EXCEL.INFOGENE',
    'PORTAL.EXCEL.FILTROSNAME',


    ];
  //variables que tomaran las traducciones indicadas en la variable anterior
  //deben ir en el mismo orden
  mensajesTraducirTS = {
    guarda_1: '',
    guarda_2: '',
    guardado: '',
    gua_err: '',
    delete_1: '',
    delete_2: '',
    del_ok_1: '',
    del_ok_2: '',
    del_err: '',
    delfile: '',
    excel: '',
    extmal: '',
    norows: '',
    vacio: '',
    si: '',
    no: '',
    hoja: '',
    titulo: '',
    autor: '',
    asunto: '',
    errDel: '',
    nomempre:'',
    nomusuario:'',
    nomprod:'',
    fechlanza:'',
    fechdesca:'',
    drestan:'',
    totalcola:'',
    totalfal:'',
    totalcont:'',
    totalpro:'',
    reporte:'',
    ranking:'',
    filt:'',
    nomfilt:'',
    infogene:'',
    filtrosname:'',
  };

  nombresColumnas: string[] = [];
  datosUsuario: any;
  datosUsu: backInter.infoUsuario;
  datosEmp: backInter.infoEmpresa;
  nombreEmpresaFinal: string;
  usuarioEmpresaFinal:string;
  tipoProductoFinal:string;
  fechaProducto:string;
  IdInstituto:number;
  validarIzzi:boolean=false;
  tokenConfiguration:any;
  cargandoTablaFiltros:boolean=true;
  checked:boolean=false;
  selected:string[]=[];
  selectedSegmentos:string[]=[];
  selectedNivel1:string[]=[];
  selectedNivel2:string[]=[];
  catalogoFiltros:string[]=[];
  catalogoFiltrosSegmento:string[]=[];
  catalogoFiltrosN1:string[]=[];
  catalogoFiltrosN2:string[]=[];
  filtrosExcelV2:any;
  filteredValues = {
    Nivel_1: '', Nivel_2: '', FILTRO: '',
    SEGMENTO: ''
  };

  catalogoFiltroSeccionN_1:string[]=[];
  catalogoFiltroSeccionN_2:string[]=[];
  catalogoFiltroSeccionDemografico:string[]=[];
  catalogoFiltroSeccionSegmento:string[]=[];

  variableReservaN_1:string[]=[];
  variableReservaN_2:string[]=[];
  variableReservaDemografico:string[]=[];
  variableReservaSegmento:string[]=[];

  validacionNivel_1:boolean=false;
  validacionNivel_2:boolean=false;
  validacionDemografico:boolean=false;
  validacionSegmento:boolean=false;

  portalValidacion:boolean=false;

  checkedReducido:boolean=false;
  selectedReducido:any[]=[];
  selectedReducidoDemogradicos:any[]=[];
  selectedSegmentosReducido:string[]=[];
  selectedNivel1Reducido:string[]=[];
  selectedNivel2Reducido:string[]=[];
  catalogoFiltrosReducido:any[]=[];
  catalogoFiltrosSegmentoReducido:string[]=[];
  filtrosExcelV2Reducido:any;
  filteredValuesReducido = {
    FILTRO: '', SEGMENTO: ''
  };

  catalogoFiltroSeccionDemograficoReducido:string[]=[];
  catalogoFiltroSeccionSegmentoReducido:string[]=[];
  variableReservaDemograficoReducido:string[]=[];
  variableReservaSegmentoReducido:string[]=[];
  validacionDemograficoReducido:boolean=false;
  validacionSegmentoReducido:boolean=false;


  resultsBoxEntregables:boolean;
  resultsBoxRanking:boolean;
  textResultsBoxEntregables:any;
  textResultsBoxRanking:any;
  textToolResultsBoxEntregables:any;
  textToolResultsBoxRanking:any;
  city_name:any;
  logDate:any;
  indiceZona: number;
  diferenciaUtc: number;
  offsetPipe: string;
  zonasUTC = zonasUTC;
  urlImagenLog= DATOS_API.urlAssets;
  cajasCerPortaSurveyStatus:any;
  muestraActiva:boolean=false;
  iconMuestraActiva="keyboard_arrow_right";
  productoLeaderGo:boolean=false;
  avancesLeaderGo:any[]=[
        {text: 'Total lideres', color: '#007bff',url:'https://app04.culturalgo.com/assetsCGO5/logos/total-users.png', total:400},
        {text: 'Total Inciados', color: '#dc3545',url:'https://app04.culturalgo.com/assetsCGO5/logos/users-not-responded.png', total:200},
        {text: 'Total Finalizados', color: '#ffc107',url:'https://app04.culturalgo.com/assetsCGO5/logos/users-have-responded.png', total:200},
        {text: 'Total Porcentage', color: '#28a745',url:'https://app04.culturalgo.com/assetsCGO5/logos/meta.png', total:50},
  ];

  urlTableau="";

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private cierreService: CierreService,
    private serviceCert : cierreCertificar,
    private serviceMed : cierreMedir,
    private servicePul : cierrePulse,
    private serviceFoc : cierreFocus,
    private wizardService: wizardService,
    private conteosService: ConteosService,
    private conteoservice35: WizardService,
    private serviceNom: Cierren35Service,
    private translateSrv: TranslateService,
    public authService: AuthService,
    public dialog: MatDialog,
    private encuestaService: EncuestaService,
    private location: Location,
    private router: Router,
    private datePipe: DatePipe,
  ) {
    lang_conteos.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_toolbar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => { if(this.idFiltro )this.translateSrv.get('PORTAL.FILTROS.'+this.idFiltro).subscribe((res1: string) => { this.nombre = res1; });});
    this.translateSrv.onLangChange.subscribe(() => { this.translateSrv.get('PORTAL35.SELECTFPLA').subscribe((res1: string) => { this.nombreCT = res1; });});
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); this.getStatusCierre(); });

    if(localStorage.getItem('tipoIzzi')){
      this.validarIzzi = true;
    }

  }

  ngOnInit() {
    this.cajasCerPortaSurveyStatus=localStorage.getItem('instituto_empresa');
    console.log('cajasCerPortaSurveyStatus',this.cajasCerPortaSurveyStatus);
    //console.log("Portal de conteos interno");
    this.datosUsu = this.authService.getInfoUsuario();
    console.log(this.datosUsu);
    this.IdInstituto=this.datosUsu.institutoId;
    // console.log("tu instituto id es ");
    // console.log(this.IdInstituto);

    this.usuarioEmpresaFinal=this.datosUsu.user;
    //console.log(this.usuarioEmpresaFinal);
    this.getInfoEmpresa();
    this.styleElement = document.createElement('style');
    this.tipoProducto = localStorage.getItem('tipoProducto');
    console.log('this.tipoProducto',this.tipoProducto);

    if (this.tipoProducto=='L1') {
      this.productoLeaderGo=true;
      this.urlProducto='/leader_GO/wizard/avance';
      this.urlTableau="https://leadergo.org/?rest_route=/simple-jwt-login/v1/autologin&JWT=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpYXQiOjE2MjY3MDk0NTIsImV4cCI6MTY1ODI0NTQ1MiwiZW1haWwiOiJqdWFuMi5hbG9uc29AaXRibS5zaSJ9.U6J2maruVw_593qIyFArQREejWQQGsrE2VU6vDruzNpnkcyev7dcVUQ3N8nd1N1gnU4xUPi9NrAkpuPYpj6S1g&redirectUrl=https://leadergo.org/es/estadisticas-del-curso/";
      setTimeout(() => {
        console.log("se dispara form alv");
        $('#RecDatos').submit();
      },1000);
    }else{
      this.productoLeaderGo=false;
    }
    console.log(this.tipoProducto);
    if(this.tipoProducto.length>0){
      this.obtieneCertificarActual();
    }
    this.cambiaColorProgress();
    this.obtieneInstituto();
    this.traduceTextosTS();
    this.calculoOffsetPipe();
    this.city_name= localStorage.getItem('nameCity');
    console.log('this.city_name',this.city_name);
    this.logDate= localStorage.getItem('date_log');
  }

  regresar(){
    console.log("this.urlProducto:",this.urlProducto);

    if(this.urlProducto == 'regresar'){
      this.location.back();
    } else{
      this.router.navigate([`/${this.urlProducto}`]);
    }
  }


mostrarCajasExtras(){
  if(!this.muestraActiva){
    this.muestraActiva=true;
    this.iconMuestraActiva="keyboard_arrow_left";

  }else{
    this.muestraActiva=false;
    this.iconMuestraActiva="keyboard_arrow_right";
  }
}
translate_name:any;
  obtieneCertificarActual(){
    this.cierreService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      console.log(data);
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      let prodsCgoExpress:backInter.productosCGOExpress[] = data.productosCGOExpress;
      let prodsMedir:backInter.prodGenerico[] = data.productosMedir2;
      let prodsPulse:backInter.prodPulseCheck[] = data.productosPulseCheck;
      var BreakException = {};
      try {
        switch (this.tipoProducto) {
          case 'f1': case 'm7': case 'p1': case 'c3': case 'c1': case 'am1': case 'td1': case 'pe1': case 'c6':
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaCertificar;
            let idProducto = producto.idCertificar;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              console.log(producto);
              this.tokenConfiguration=producto.tokenConfig;
              this.getConteoFiltroNuevaVersionReducido();
              this.getProrrogasFechaCierre(idProducto)
            }
          });

          break;

          case 'm1': case 'm2': case 'm3': case 'm4': case 'm5': case 'm6':
          prodsMedir.forEach( (producto) => {
            let fecha = producto.fechaProducto;
            let idProducto = producto.idProducto;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              console.log(producto.tokenConfig);
              this.tokenConfiguration=producto.tokenConfig;
              this.getConteoFiltroNuevaVersionReducido();
            }
          });
          break;

          case '3':
          prodsPulse.forEach( (producto) => {
            let fecha = producto.fechaPulseCheck;
            let idProducto = producto.idPulseCheck;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              console.log(producto.tokenConfig);
              this.tokenConfiguration=producto.tokenConfig;
              this.getConteoFiltroNuevaVersionReducido();
            }
          });

          break;
          case 'CGOX':
          prodsCgoExpress.forEach( (producto) => {
            let fecha = producto.date;
            let idProducto = producto._id;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              console.log(producto);
              this.tokenConfiguration=producto.surveyToken;
              this.getConteoFiltroNuevaVersionReducido();
            }
          });

          break;

          default:
            break;
        }

        switch (this.tipoProducto) { // PAra asignar nombre al producto
          case '1':  this.translate_name="PORTAL.PRODUCTO.CERT"; break;
          case 'c1': this.translate_name="PORTAL.PRODUCTO.CERT"; break;
          case 'c3': this.translate_name="PORTAL.PRODUCTO.CERT"; break;
          case 'p1': this.translate_name="PORTAL.PRODUCTO.PULSE"; break;
          case 'f1': this.translate_name="PORTAL.PRODUCTO.FOCUS"; break;
          case 'm7': this.translate_name="PORTAL.PRODUCTO.MEDIR_1"; break;
          case 'm1': this.translate_name="PORTAL.PRODUCTO.MEDIR_1"; break;
          case 'm2': this.translate_name="PORTAL.PRODUCTO.MEDIR_2"; break;
          case 'm3': this.translate_name="PORTAL.PRODUCTO.MEDIR_3";break;
          case 'm4': this.translate_name="PORTAL.PRODUCTO.MEDIR_4";break;
          case 'm5': this.translate_name="PORTAL.PRODUCTO.MEDIR_5";break;
          case 'm6': this.translate_name="PORTAL.PRODUCTO.MEDIR_6";break;
          case '3' : this.translate_name="PORTAL.PRODUCTO.PULSE";break;
          case '5': this.translate_name="PORTAL.PRODUCTO.NOM35"; break;
          case 'NOM35V3': this.translate_name="PORTAL.PRODUCTO.NOM35"; break;
          case 'L1': this.translate_name="PORTAL.PRODUCTO.LEADER_GO"; break;
          case 'am1': this.translate_name="PORTAL.PRODUCTO.AMCO"; break;
          case 'td1': this.translate_name="PORTAL.PRODUCTO.TRAB_DIGN"; break;
          case 'pe1': this.translate_name="PORTAL.PRODUCTO.PRI_EMPLE"; break;
          case 'CGOX': this.translate_name="PORTAL.PRODUCTO.CGO_EXPRE"; break;
          case 'c6': this.translate_name="PORTAL.PRODUCTO.GPTW_GCTI"; break;
          default:   break;
        }
        let texto=this.translate_name;
        this.translateSrv.get(texto).subscribe((res: string) => { texto= res; });
        this.translate_name=texto;

        // this.translate_name = this.translate_name + localStorage.getItem('fechaProducto');
        this.translate_name = this.tipoProducto == 'NOM35V3' ? this.translate_name + "  "+localStorage.getItem('FechaNorma'): this.translate_name + "  "+localStorage.getItem('fechaProducto');

      } catch (e) {
          if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
      console.log(error);
    });
  }

  calculoOffsetPipe(diff?:any){
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == parseInt(localStorage.getItem('instituto_id')));
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
  let horas = diff!=undefined?diff/60:this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
    console.log(localStorage.getItem('instituto_id'));
    console.log(localStorage.getItem('instituto_empresa'));
    this.city_name='TOOLBAR.CITIES.'+localStorage.getItem('instituto_id');
  }





  customFilterPredicate() {
    const myFilterPredicate = (data: filtrosPortalConteosV2, filter: string): boolean => {
      let searchString = JSON.parse(filter);
      return data.Nivel_1.toString().trim().indexOf(searchString.Nivel_1) !== -1 &&
        data.Nivel_2.toString().trim().toLowerCase().indexOf(searchString.Nivel_2.toLowerCase()) !== -1 &&
        data.FILTRO.toString().trim().toLowerCase().indexOf(searchString.FILTRO.toLowerCase()) !== -1 &&
        data.SEGMENTO.toString().trim().toLowerCase().indexOf(searchString.SEGMENTO.toLowerCase()) !== -1;
    }
    return myFilterPredicate;
  }

  applyFilter(filterValue: any) {
     // this.filtroPortalv2.filter = filterValue.trim().toLowerCase();
     this.filtroPortalv2.filter = JSON.stringify(this.filteredValues);
   }

   seleccionarFiltro(nivel1: string){
     this.validacionNivel_1=true;
     let selectedNivel2:string[]=[];
     let selected:string[]=[];
     let selectedSegmentos:string[]=[];
     let nivel2:boolean=false;
     let filtro:boolean=false;
     let segmento:boolean=false;
     this.filteredValues['Nivel_1'] = nivel1;
     this.filtroPortalv2.filter = JSON.stringify(this.filteredValues);

    this.filtroPortalv2.filterPredicate = this.customFilterPredicate();
       // this.applyFilter(cargo);
       if(nivel1.length>0){
         if(this.validacionNivel_2==false){
           this.filtroPortalv2.filteredData.forEach(nivel2 => {
             if(nivel2.Nivel_1!="Fecha Consulta"){
               selectedNivel2.push(nivel2.Nivel_2);
             }
           });
           this.catalogoFiltroSeccionN_2 =Array.from(new Set(selectedNivel2)).sort();
           this.catalogoFiltrosN2=this.catalogoFiltroSeccionN_2;
         }
         else{
           if(this.filtroPortalv2.filteredData.length<1){
             this.seleccionarFiltro2('');
             nivel2=true;
           }
         }

         if(this.validacionDemografico==false){
           this.filtroPortalv2.filteredData.forEach(nombrefiltro => {
             if(nombrefiltro.Nivel_1!="Fecha Consulta"){
               selected.push(nombrefiltro.FILTRO);
             }
           });
           this.catalogoFiltroSeccionDemografico = Array.from(new Set(selected)).sort();
           this.catalogoFiltros=this.catalogoFiltroSeccionDemografico;
         }
         else{
           if(this.filtroPortalv2.filteredData.length<1){
             this.seleccionarFiltro3('');
             filtro=true;
           }
         }

         if(this.validacionSegmento==false){
           this.filtroPortalv2.filteredData.forEach(segmentofiltro => {
             if(segmentofiltro.Nivel_1!="Fecha Consulta"){
               selectedSegmentos.push(segmentofiltro.SEGMENTO);
             }
           });
           this.catalogoFiltroSeccionSegmento=Array.from(new Set(selectedSegmentos)).sort();
           this.catalogoFiltrosSegmento=this.catalogoFiltroSeccionSegmento;
         }
         else{
           if(this.filtroPortalv2.filteredData.length<1){
             this.seleccionarFiltro4('');
             segmento=true;
           }
         }
         if(nivel2==true){
           this.filtroPortalv2.filteredData.forEach(nivel2 => {
             if(nivel2.Nivel_1!="Fecha Consulta"){
               selectedNivel2.push(nivel2.Nivel_2);
             }
           });
           this.catalogoFiltroSeccionN_2 =Array.from(new Set(selectedNivel2)).sort();
           this.catalogoFiltrosN2=this.catalogoFiltroSeccionN_2;
         }

         if(filtro==true){
           this.filtroPortalv2.filteredData.forEach(nombrefiltro => {
             if(nombrefiltro.Nivel_1!="Fecha Consulta"){
               selected.push(nombrefiltro.FILTRO);
             }
           });
           this.catalogoFiltroSeccionDemografico = Array.from(new Set(selected)).sort();
           this.catalogoFiltros=this.catalogoFiltroSeccionDemografico;
         }

         if(segmento==true){
           this.filtroPortalv2.filteredData.forEach(segmentofiltro => {
             if(segmentofiltro.Nivel_1!="Fecha Consulta"){
               selectedSegmentos.push(segmentofiltro.SEGMENTO);
             }
           });
           this.catalogoFiltroSeccionSegmento=Array.from(new Set(selectedSegmentos)).sort();
           this.catalogoFiltrosSegmento=this.catalogoFiltroSeccionSegmento;
         }
       }
       else{
         if(this.validacionNivel_2==false){
           this.catalogoFiltrosN2=this.variableReservaN_2;
         }
         if(this.validacionDemografico==false){
           this.catalogoFiltros=this.variableReservaDemografico;
         }
         if(this.validacionSegmento==false){
           this.catalogoFiltrosSegmento=this.variableReservaSegmento;
         }
         this.validacionNivel_1=false;
       }
   }

   seleccionarFiltro2(nivel2: string){
     this.validacionNivel_2=true;
     let selectedNivel1:string[]=[];
     let selected:string[]=[];
     let selectedSegmentos:string[]=[];

     let nivel1:boolean=false;
     let filtro:boolean=false;
     let segmento:boolean=false;
     this.filteredValues['Nivel_2'] = nivel2;
     this.filtroPortalv2.filter = JSON.stringify(this.filteredValues);

     if(nivel2.length>0){
       if(this.validacionNivel_1==false){
         this.filtroPortalv2.filteredData.forEach(nivel1 => {
           if(nivel1.Nivel_1!="Fecha Consulta"){
             selectedNivel1.push(nivel1.Nivel_1);
           }
         });
         this.catalogoFiltroSeccionN_1 =Array.from(new Set(selectedNivel1)).sort();
         this.catalogoFiltrosN1=this.catalogoFiltroSeccionN_1;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro('');
           nivel1=true;
         }
       }

       if(this.validacionDemografico==false){
         this.filtroPortalv2.filteredData.forEach(nombrefiltro => {
           if(nombrefiltro.Nivel_1!="Fecha Consulta"){
             selected.push(nombrefiltro.FILTRO);
           }
         });
         this.catalogoFiltroSeccionDemografico = Array.from(new Set(selected)).sort();
         this.catalogoFiltros=this.catalogoFiltroSeccionDemografico;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro3('');
           filtro=true;
         }
       }

       if(this.validacionSegmento==false){
         this.filtroPortalv2.filteredData.forEach(segmentofiltro => {
           if(segmentofiltro.Nivel_1!="Fecha Consulta"){
             selectedSegmentos.push(segmentofiltro.SEGMENTO);
           }
         });
         this.catalogoFiltroSeccionSegmento=Array.from(new Set(selectedSegmentos)).sort();
         this.catalogoFiltrosSegmento=this.catalogoFiltroSeccionSegmento;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro4('');
           segmento=true;
         }
       }

       if(nivel1==true){
         this.filtroPortalv2.filteredData.forEach(nivel1 => {
           if(nivel1.Nivel_1!="Fecha Consulta"){
             selectedNivel1.push(nivel1.Nivel_1);
           }
         });
         this.catalogoFiltroSeccionN_1 =Array.from(new Set(selectedNivel1)).sort();
         this.catalogoFiltrosN1=this.catalogoFiltroSeccionN_1;
       }

       if(filtro==true){
         this.filtroPortalv2.filteredData.forEach(nombrefiltro => {
           if(nombrefiltro.Nivel_1!="Fecha Consulta"){
             selected.push(nombrefiltro.FILTRO);
           }
         });
         this.catalogoFiltroSeccionDemografico = Array.from(new Set(selected)).sort();
         this.catalogoFiltros=this.catalogoFiltroSeccionDemografico;
       }

       if(segmento==true){
         this.filtroPortalv2.filteredData.forEach(segmentofiltro => {
           if(segmentofiltro.Nivel_1!="Fecha Consulta"){
             selectedSegmentos.push(segmentofiltro.SEGMENTO);
           }
         });
         this.catalogoFiltroSeccionSegmento=Array.from(new Set(selectedSegmentos)).sort();
         this.catalogoFiltrosSegmento=this.catalogoFiltroSeccionSegmento;
       }

     }
     else{
       if(this.validacionNivel_1==false){
         this.catalogoFiltrosN1=this.variableReservaN_1;
       }
       if(this.validacionDemografico==false){
         this.catalogoFiltros=this.variableReservaDemografico;
       }
       if(this.validacionSegmento==false){
         this.catalogoFiltrosSegmento=this.variableReservaSegmento;
       }
       this.validacionNivel_2=false;
     }


    this.filtroPortalv2.filterPredicate = this.customFilterPredicate();
   }

   seleccionarFiltro3(filtro: string){
     this.validacionDemografico=true;
     let selectedNivel1:string[]=[];
     let selectedNivel2:string[]=[];
     let selectedSegmentos:string[]=[];

     let nivel1:boolean=false;
     let nivel2:boolean=false;
     let segmento:boolean=false;

     this.filteredValues['FILTRO'] = filtro;
     this.filtroPortalv2.filter = JSON.stringify(this.filteredValues);

     if(filtro.length>0){
       if(this.validacionNivel_1==false){
         this.filtroPortalv2.filteredData.forEach(nivel1 => {
           if(nivel1.Nivel_1!="Fecha Consulta"){
             selectedNivel1.push(nivel1.Nivel_1);
           }
         });
         this.catalogoFiltroSeccionN_1 =Array.from(new Set(selectedNivel1)).sort();
         this.catalogoFiltrosN1=this.catalogoFiltroSeccionN_1;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro('');
           nivel1=true;
         }
       }

       if(this.validacionNivel_2==false){
         this.filtroPortalv2.filteredData.forEach(nivel2 => {
           if(nivel2.Nivel_1!="Fecha Consulta"){
             selectedNivel2.push(nivel2.Nivel_2);
           }
         });
         this.catalogoFiltroSeccionN_2 =Array.from(new Set(selectedNivel2)).sort();
         this.catalogoFiltrosN2=this.catalogoFiltroSeccionN_2;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro2('');
           nivel2=true;
         }
       }

       if(this.validacionSegmento==false){
         this.filtroPortalv2.filteredData.forEach(segmentofiltro => {
           if(segmentofiltro.Nivel_1!="Fecha Consulta"){
             selectedSegmentos.push(segmentofiltro.SEGMENTO);
           }
         });
         this.catalogoFiltroSeccionSegmento=Array.from(new Set(selectedSegmentos)).sort();
         this.catalogoFiltrosSegmento=this.catalogoFiltroSeccionSegmento;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro4('');
           segmento=true;
         }
       }

       if(nivel1==true){
         this.filtroPortalv2.filteredData.forEach(nivel1 => {
           if(nivel1.Nivel_1!="Fecha Consulta"){
             selectedNivel1.push(nivel1.Nivel_1);
           }
         });
         this.catalogoFiltroSeccionN_1 =Array.from(new Set(selectedNivel1)).sort();
         this.catalogoFiltrosN1=this.catalogoFiltroSeccionN_1;
       }

       if(nivel2==true){
         this.filtroPortalv2.filteredData.forEach(nivel2 => {
           if(nivel2.Nivel_1!="Fecha Consulta"){
             selectedNivel2.push(nivel2.Nivel_2);
           }
         });
         this.catalogoFiltroSeccionN_2 =Array.from(new Set(selectedNivel2)).sort();
         this.catalogoFiltrosN2=this.catalogoFiltroSeccionN_2;
       }

       if(segmento==true){
         this.filtroPortalv2.filteredData.forEach(segmentofiltro => {
           if(segmentofiltro.Nivel_1!="Fecha Consulta"){
             selectedSegmentos.push(segmentofiltro.SEGMENTO);
           }
         });
         this.catalogoFiltroSeccionSegmento=Array.from(new Set(selectedSegmentos)).sort();
         this.catalogoFiltrosSegmento=this.catalogoFiltroSeccionSegmento;
       }

     }
     else{
       if(this.validacionNivel_1==false){
         this.catalogoFiltrosN1=this.variableReservaN_1;
       }
       if(this.validacionNivel_2==false){
         this.catalogoFiltrosN2=this.variableReservaN_2;
       }
       if(this.validacionSegmento==false){
         this.catalogoFiltrosSegmento=this.variableReservaSegmento;
       }
       this.validacionDemografico=false;
     }


    this.filtroPortalv2.filterPredicate = this.customFilterPredicate();
   }

   seleccionarFiltro4(segmento: string){
     this.validacionSegmento=true;
     let selectedNivel1:string[]=[];
     let selectedNivel2:string[]=[];
     let selected:string[]=[];

     let nivel1:boolean=false;
     let nivel2:boolean=false;
     let filtro:boolean=false;

     this.filteredValues['SEGMENTO'] = segmento;
     this.filtroPortalv2.filter = JSON.stringify(this.filteredValues);

     if(segmento.length>0){
       if(this.validacionNivel_1==false){
         this.filtroPortalv2.filteredData.forEach(nivel1 => {
           if(nivel1.Nivel_1!="Fecha Consulta"){
             selectedNivel1.push(nivel1.Nivel_1);
           }
         });
         this.catalogoFiltroSeccionN_1 =Array.from(new Set(selectedNivel1)).sort();
         this.catalogoFiltrosN1=this.catalogoFiltroSeccionN_1;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro('');
           nivel1=true;
         }
       }

       if(this.validacionNivel_2==false){
         this.filtroPortalv2.filteredData.forEach(nivel2 => {
           if(nivel2.Nivel_1!="Fecha Consulta"){
             selectedNivel2.push(nivel2.Nivel_2);
           }
         });
         this.catalogoFiltroSeccionN_2 =Array.from(new Set(selectedNivel2)).sort();
         this.catalogoFiltrosN2=this.catalogoFiltroSeccionN_2;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro2('');
           nivel2=true;
         }
       }

       if(this.validacionDemografico==false){
         this.filtroPortalv2.filteredData.forEach(nombrefiltro => {
           if(nombrefiltro.Nivel_1!="Fecha Consulta"){
             selected.push(nombrefiltro.FILTRO);
           }
         });
         this.catalogoFiltroSeccionDemografico = Array.from(new Set(selected)).sort();
         this.catalogoFiltros=this.catalogoFiltroSeccionDemografico;
       }
       else{
         if(this.filtroPortalv2.filteredData.length<1){
           this.seleccionarFiltro3('');
           filtro=true;
         }
       }

       if(nivel1==true){
         this.filtroPortalv2.filteredData.forEach(nivel1 => {
           if(nivel1.Nivel_1!="Fecha Consulta"){
             selectedNivel1.push(nivel1.Nivel_1);
           }
         });
         this.catalogoFiltroSeccionN_1 =Array.from(new Set(selectedNivel1)).sort();
         this.catalogoFiltrosN1=this.catalogoFiltroSeccionN_1;
       }

       if(nivel2==true){
         this.filtroPortalv2.filteredData.forEach(nivel2 => {
           if(nivel2.Nivel_1!="Fecha Consulta"){
             selectedNivel2.push(nivel2.Nivel_2);
           }
         });
         this.catalogoFiltroSeccionN_2 =Array.from(new Set(selectedNivel2)).sort();
         this.catalogoFiltrosN2=this.catalogoFiltroSeccionN_2;
       }

       if(filtro==true){
         this.filtroPortalv2.filteredData.forEach(nombrefiltro => {
           if(nombrefiltro.Nivel_1!="Fecha Consulta"){
             selected.push(nombrefiltro.FILTRO);
           }
         });
         this.catalogoFiltroSeccionDemografico = Array.from(new Set(selected)).sort();
         this.catalogoFiltros=this.catalogoFiltroSeccionDemografico;
       }

     }
     else{
       if(this.validacionNivel_1==false){
         this.catalogoFiltrosN1=this.variableReservaN_1;
       }
       if(this.validacionNivel_2==false){
         this.catalogoFiltrosN2=this.variableReservaN_2;
       }
       if(this.validacionDemografico==false){
         this.catalogoFiltros=this.variableReservaDemografico;
       }
       this.validacionSegmento=false;
     }


    this.filtroPortalv2.filterPredicate = this.customFilterPredicate();
   }

  getConteoFiltroNuevaVersion(){
    let label1='PORTAL.ETIQUETAS.ETIQUETAS';
    let label2='PORTAL.ETIQUETAS.OF';
    this.translateSrv.get(label1).subscribe((res: string) => { label1= res; });
    this.translateSrv.get(label2).subscribe((res: string) => { label2= res; });

    this.conteosService.getConteoFiltroNuevaVersion(this.tokenConfiguration).subscribe( (data:backInter.portalConteosV2) => {
      console.log(data);
      data.result.forEach(nombrefiltro => {
        if(nombrefiltro.Nivel_1!="Fecha Consulta"){
          this.selected.push(nombrefiltro.FILTRO);
        }
      });

      data.result.forEach(segmentofiltro => {
        if(segmentofiltro.Nivel_1!="Fecha Consulta"){
          this.selectedSegmentos.push(segmentofiltro.SEGMENTO);
        }
      });

      data.result.forEach(nivel1 => {
        if(nivel1.Nivel_1!="Fecha Consulta"){
          this.selectedNivel1.push(nivel1.Nivel_1);
        }
      });

      data.result.forEach(nivel2 => {
        if(nivel2.Nivel_1!="Fecha Consulta"){
          this.selectedNivel2.push(nivel2.Nivel_2);
        }
      });

      // console.log(this.selected);
      this.catalogoFiltros = Array.from(new Set(this.selected));
      this.catalogoFiltrosSegmento=Array.from(new Set(this.selectedSegmentos)).sort();
      this.catalogoFiltrosN1 =Array.from(new Set(this.selectedNivel1)).sort();
      this.catalogoFiltrosN2 =Array.from(new Set(this.selectedNivel2)).sort();
      this.variableReservaN_1=this.catalogoFiltrosN1;
      this.variableReservaN_2=this.catalogoFiltrosN2;
      this.variableReservaDemografico=this.catalogoFiltros;
      this.variableReservaSegmento=this.catalogoFiltrosSegmento;
      data.result.splice(1, 1);
      this.filtrosExcelV2=data.result;
      this.filtroPortalv2 = new MatTableDataSource(data.result);
      this.filtroPortalv2.sort=this.sort;
      this.seleccionarFiltro('');
      setTimeout(() => this.filtroPortalv2.paginator=this.paginator);
      setTimeout(() => this.paginator._intl.itemsPerPageLabel=label1);
      setTimeout(() => this.paginator._intl.getRangeLabel=(page: number, pageSize: number, length: number) => { if (length == 0 || pageSize == 0)
        { return `0 ${label2} ${length}`; } length = Math.max(length, 0); const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} – ${endIndex} ${label2} ${length}`; });
      this.cargandoTablaFiltros= false;
    },error=>{
      console.log("Error getConteoFiltroNuevaVersion");
    });
  }

  descargarExcelV2(){
    let nivel1: string;
    let nivel2: string;
    let demografico: string;
    let segmento: string;
    let total: string;
    let pendientes: string;
    let respondieron: string;
    let avancetexto: string;

    let tituloAvance: string;
    let sheet: string;
    let modal: string;
    let descarga: string;

    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.NIVEL1').subscribe((res: string) => { nivel1 = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.NIVEL2').subscribe((res: string) => { nivel2 = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.DEMOGRAFICO').subscribe((res: string) => { demografico = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.SEGMENTO').subscribe((res: string) => { segmento = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.COLABORADORES_T').subscribe((res: string) => { total = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.PENDIENTES_RESPONDER').subscribe((res: string) => { pendientes = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.YA_RESPONDIERON').subscribe((res: string) => { respondieron = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.AVANCE').subscribe((res: string) => { avancetexto = res; });

    this.translateSrv.get('PORTAL.EXCEL_V2.TITULO_AVANCE').subscribe((res: string) => { tituloAvance = res; });
    this.translateSrv.get('PORTAL.EXCEL_V2.SHEET').subscribe((res: string) => { sheet = res; });
    this.translateSrv.get('PORTAL.EXCEL_V2.DESCARGA').subscribe((res: string) => { modal = res; });
    this.translateSrv.get('PORTAL.EXCEL_V2.MODAL_DESCARGA').subscribe((res: string) => { descarga = res; });
    Swal.fire({
      title: this.mensajesTraducirTS.excel,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    let fecha = new Date();
    let fechaCompleta = fecha.getDate()+"/"+(fecha.getMonth()+1)+"/"+fecha.getFullYear();
    let hora = fecha.getHours()+":"+fecha.getMinutes()+":"+fecha.getSeconds();
    //Excel Title, Header, Data
    const title = this.nombreEmpresaFinal;
    const avance = tituloAvance+fechaCompleta+" "+hora;
    const header = [nivel1, nivel2, demografico, segmento, total, pendientes, respondieron, avancetexto]

    //Create workbook and worksheet
    const Excel = require('exceljs');
    const workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet(sheet);
    workbook.creator = 'CULTURAL GO PLATFORM';
    workbook.title = 'CULTURAL GO PLATFORM';

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    let avanceRow = worksheet.addRow([avance]);
    titleRow.font = { name: 'Calibri', family: 4, size: 14, underline: 'double', bold: true }
    avanceRow.font = { name: 'Calibri', family: 4, size: 14, bold: true }

    //Add Image
    // let logo = workbook.addImage({
    //   base64: logoFile.logoBase64,
    //   extension: 'png',
    // });
    // worksheet.addImage(logo, 'E1:F3');
    worksheet.mergeCells('A1:H1');
    worksheet.mergeCells('A2:H2');
    //Blank Row
    // worksheet.addRow([]);
    //Add Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.font = { name: 'Calibri', family: 4, bold: true }

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D8D8D8' }
        // bgColor: { argb: 'B8B5B5' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    this.filtrosExcelV2.forEach(element => {
      let porcentaje:any=((element.PROGRESO_TOTAL*100).toFixed(2));
      let porcentajeFinal:any;
      if(element.COLABORADORES_QUE_AUN_NO_RESPONDEN!='*' || element.COLABORADORES_QUE_YA_RESPONDIERON!='*'){
        porcentaje=((element.PROGRESO_TOTAL*100).toFixed(2));
        porcentajeFinal=parseFloat(porcentaje);
      }
      else{
      porcentajeFinal='*';
      }
      worksheet.addRow([element.Nivel_1,
        element.Nivel_2,
        element.FILTRO,
        element.SEGMENTO,
        element.TOTAL_DE_COLABORADORES,
        element.COLABORADORES_QUE_AUN_NO_RESPONDEN,
        element.COLABORADORES_QUE_YA_RESPONDIERON,
        porcentajeFinal
      ]);
    });
    // worksheet.addRows(data);
    // Add Data and Conditional Formatting
    // data.forEach(d => {
    //   let row = worksheet.addRow(d);
    //   let qty = row.getCell(5);
    //   let color = 'FF99FF99';
    //   if (+qty.value < 500) {
    //     color = 'FF9999'
    //   }
    //   qty.fill = {
    //     type: 'pattern',
    //     pattern: 'solid',
    //     fgColor: { argb: color }
    //   }
    // }
    // );
    worksheet.autoFilter = 'A3:H3';
    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };

    worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('B3').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('C3').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('D3').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('E3').alignment = { vertical: 'justify', horizontal: 'center' };
    worksheet.getCell('F3').alignment = { vertical: 'justify', horizontal: 'center' };
    worksheet.getCell('G3').alignment = { vertical: 'justify', horizontal: 'center' };
    worksheet.getCell('H3').alignment = { vertical: 'middle', horizontal: 'center' };


    worksheet.getColumn(1).width = 40;
    worksheet.getColumn(2).width = 40;
    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 40;
    worksheet.getColumn(5).width = 18;
    worksheet.getColumn(6).width = 18;
    worksheet.getColumn(7).width = 18;
    worksheet.getColumn(8).width = 30;
    worksheet.addRow([]);
    //Footer Row
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs.saveAs(blob,modal+this.nombreEmpresaFinal+'.xlsx');
      Swal.close();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: descarga,
        showConfirmButton: false,
        timer: 1500
      })
    })
  }

  customFilterPredicateReducido() {
    const myFilterPredicateReducido = (data: filtrosPortalConteosV2Reducido, filter: string): boolean => {

      let searchString = JSON.parse(filter);
      return data.FILTRO.toString().toLowerCase().indexOf(searchString.FILTRO.toLowerCase()) !== -1 &&
      data.SEGMENTO.toString().toLowerCase().indexOf(searchString.SEGMENTO.toLowerCase()) !== -1;
    }
    return myFilterPredicateReducido;

  }

  seleccionarFiltroReducido(filtro: any){
    this.validacionDemograficoReducido=true;
    let selectedSegmentos:string[]=[];

    this.filteredValuesReducido['FILTRO'] = filtro;
    this.filtroPortalv2Reducido.filter = JSON.stringify(this.filteredValuesReducido);
    this.filtroPortalv2Reducido.filterPredicate = this.customFilterPredicateReducido();
    if(filtro.length>0){
      if(this.validacionSegmentoReducido==false){
        this.filtroPortalv2Reducido.filteredData.forEach(segmentofiltro => {
          if(segmentofiltro.FILTRO!="Fecha Consulta"){
            selectedSegmentos.push(segmentofiltro.SEGMENTO);
          }
        });
        this.catalogoFiltroSeccionSegmentoReducido=Array.from(new Set(selectedSegmentos)).sort();
        this.catalogoFiltrosSegmentoReducido=this.catalogoFiltroSeccionSegmentoReducido;
      }
      else{
        if(this.filtroPortalv2Reducido.filteredData.length<1){
          this.seleccionarFiltroReducido2('');
          this.filtroPortalv2Reducido.filteredData.forEach(segmentofiltro => {
            console.log("segmentosFiltros: ",segmentofiltro);

            if(segmentofiltro.FILTRO!="Fecha Consulta" && filtro==segmentofiltro.FILTRO ){
              selectedSegmentos.push(segmentofiltro.SEGMENTO);
            }
          });
          this.catalogoFiltroSeccionSegmentoReducido=Array.from(new Set(selectedSegmentos)).sort();
          this.catalogoFiltrosSegmentoReducido=this.catalogoFiltroSeccionSegmentoReducido;
        }
      }

    }
    else{
      if(this.validacionSegmentoReducido==false){
        this.catalogoFiltrosSegmento=this.variableReservaSegmentoReducido;
      }
      this.validacionDemograficoReducido=false;
    }
  }

  seleccionarFiltroReducido2(segmento: string){
    this.validacionSegmentoReducido=true;
    let selected:string[]=[];

    this.filteredValuesReducido['SEGMENTO'] = segmento;
    this.filtroPortalv2Reducido.filter = JSON.stringify(this.filteredValuesReducido);

    if(segmento.length>0){
      if(this.validacionDemograficoReducido==false){
        this.filtroPortalv2Reducido.filteredData.forEach(nombrefiltro => {
          if(nombrefiltro.FILTRO!="Fecha Consulta"){
            selected.push(nombrefiltro.FILTRO);
          }
        });
        this.catalogoFiltroSeccionDemograficoReducido = Array.from(new Set(selected)).sort();
        this.catalogoFiltrosReducido=this.catalogoFiltroSeccionDemograficoReducido;
      }
      else{
        if(this.filtroPortalv2Reducido.filteredData.length<1){
          this.seleccionarFiltroReducido('');
          this.filtroPortalv2Reducido.filteredData.forEach(nombrefiltro => {
            if(nombrefiltro.FILTRO!="Fecha Consulta"){
              selected.push(nombrefiltro.FILTRO);
            }
          });
          this.catalogoFiltroSeccionDemograficoReducido = Array.from(new Set(selected)).sort();
          this.catalogoFiltrosReducido=this.catalogoFiltroSeccionDemograficoReducido;
        }
      }

    }
    else{
      if(this.validacionDemograficoReducido==false){
        this.catalogoFiltrosReducido=this.variableReservaDemograficoReducido;
      }
      this.validacionSegmentoReducido=false;
    }

   this.filtroPortalv2Reducido.filterPredicate = this.customFilterPredicateReducido();
  }

  getConteoFiltroNuevaVersionReducido(){
    let label1='PORTAL.ETIQUETAS.ETIQUETAS';
    let label2='PORTAL.ETIQUETAS.OF';
    this.translateSrv.get(label1).subscribe((res: string) => { label1= res; });
    this.translateSrv.get(label2).subscribe((res: string) => { label2= res; });
    this.conteosService.getConteoExcelVersionReducida(this.tokenConfiguration).subscribe( (data:backInter.portalConteosV2Reducido) => {
      console.log(data);
      data.result.forEach(nombrefiltro => {
        nombrefiltro.visible=true;
          if(nombrefiltro.FILTRO!="Fecha Consulta"){
            this.selectedReducido.push(nombrefiltro.FILTRO);
          }
  });


  console.log('this.selectedReducido',this.selectedReducido);
      data.result.forEach(segmentofiltro => {
        if(segmentofiltro.FILTRO!="Fecha Consulta"){
          this.selectedSegmentosReducido.push(segmentofiltro.SEGMENTO);
        }
      });

      this.selectedReducido.forEach(filtroName => {
        this.selectedReducidoDemogradicos.push({nombrefiltro:filtroName,visible:true});
      });
      // console.log(this.selected);

      var hash = {};
      this.selectedReducidoDemogradicos = this.selectedReducidoDemogradicos.filter(function(current) {
        var exists = !hash[current.nombrefiltro];
        hash[current.nombrefiltro] = true;
        return exists;
      });

      this.catalogoFiltrosReducido = Array.from(new Set(this.selectedReducidoDemogradicos));
      this.catalogoFiltrosSegmentoReducido=Array.from(new Set(this.selectedSegmentosReducido)).sort();
      this.variableReservaDemograficoReducido=this.catalogoFiltrosReducido;
      this.variableReservaSegmentoReducido=this.catalogoFiltrosSegmentoReducido;
      data.result.splice(1, 1);
      this.filtrosExcelV2Reducido=data.result;
      this.filtroPortalv2Reducido = new MatTableDataSource(data.result);
      this.seleccionarFiltroReducido('');
      this.getConteoFiltroNuevaVersion();
      this.seleccionarFiltroReducido('Company');
    });
  }

  descargarExcelReducido(){
    let demografico: string;
    let segmento: string;
    let total: string;
    let pendientes: string;
    let respondieron: string;
    let avancetexto: string;

    let tituloAvance: string;
    let sheet: string;
    let modal: string;
    let descarga: string;

    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.DEMOGRAFICO').subscribe((res: string) => { demografico = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.SEGMENTO').subscribe((res: string) => { segmento = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.COLABORADORES_T').subscribe((res: string) => { total = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.PENDIENTES_RESPONDER').subscribe((res: string) => { pendientes = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.YA_RESPONDIERON').subscribe((res: string) => { respondieron = res; });
    this.translateSrv.get('PORTAL.COLUMNAS_TABLA.AVANCE').subscribe((res: string) => { avancetexto = res; });

    this.translateSrv.get('PORTAL.EXCEL_V2.TITULO_AVANCE').subscribe((res: string) => { tituloAvance = res; });
    this.translateSrv.get('PORTAL.EXCEL_V2.SHEET').subscribe((res: string) => { sheet = res; });
    this.translateSrv.get('PORTAL.EXCEL_V2.DESCARGA').subscribe((res: string) => { modal = res; });
    this.translateSrv.get('PORTAL.EXCEL_V2.MODAL_DESCARGA').subscribe((res: string) => { descarga = res; });
    Swal.fire({
      title: this.mensajesTraducirTS.excel,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    let fecha = new Date();
    let fechaCompleta = fecha.getDate()+"/"+(fecha.getMonth()+1)+"/"+fecha.getFullYear();
    let hora = fecha.getHours()+":"+fecha.getMinutes()+":"+fecha.getSeconds();
    //Excel Title, Header, Data
    const title = this.nombreEmpresaFinal;
    const avance = tituloAvance+fechaCompleta+" "+hora;
    const header = [demografico, segmento, total, pendientes, respondieron, avancetexto]

    //Create workbook and worksheet
    const Excel = require('exceljs');
    const workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet(sheet);
    workbook.creator = 'CULTURAL GO PLATFORM';
    workbook.title = 'CULTURAL GO PLATFORM';

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    let avanceRow = worksheet.addRow([avance]);
    titleRow.font = { name: 'Calibri', family: 4, size: 14, underline: 'double', bold: true }
    avanceRow.font = { name: 'Calibri', family: 4, size: 14, bold: true }


    worksheet.mergeCells('A1:F1');
    worksheet.mergeCells('A2:F2');

    let headerRow = worksheet.addRow(header);
    headerRow.font = { name: 'Calibri', family: 4, bold: true }

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D8D8D8' }
        // bgColor: { argb: 'B8B5B5' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    this.filtrosExcelV2Reducido.forEach(element => {
      let porcentaje:any=((element.PROGRESO_TOTAL*100).toFixed(2));
      let porcentajeFinal:any;
      if(element.COLABORADORES_QUE_AUN_NO_RESPONDEN!='*' || element.COLABORADORES_QUE_YA_RESPONDIERON!='*'){
        porcentaje=((element.PROGRESO_TOTAL*100).toFixed(2));
        porcentajeFinal=parseFloat(porcentaje);
      }
      else{
      porcentajeFinal='*';
      }
      worksheet.addRow([
        element.FILTRO,
        element.SEGMENTO,
        element.TOTAL_DE_COLABORADORES,
        element.COLABORADORES_QUE_AUN_NO_RESPONDEN,
        element.COLABORADORES_QUE_YA_RESPONDIERON,
        porcentajeFinal
      ]);
    });

    worksheet.autoFilter = 'A3:F3';
    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };

    worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('B3').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('C3').alignment = { vertical: 'justify', horizontal: 'center' };
    worksheet.getCell('D3').alignment = { vertical: 'justify', horizontal: 'center' };
    worksheet.getCell('E3').alignment = { vertical: 'justify', horizontal: 'center' };
    worksheet.getCell('F3').alignment = { vertical: 'middle', horizontal: 'center' };


    worksheet.getColumn(1).width = 30;
    worksheet.getColumn(2).width = 40;
    worksheet.getColumn(3).width = 18;
    worksheet.getColumn(4).width = 18;
    worksheet.getColumn(5).width = 18;
    worksheet.getColumn(6).width = 30;
    worksheet.addRow([]);
    //Footer Row
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs.saveAs(blob,modal+this.nombreEmpresaFinal+'.xlsx');
      Swal.close();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: descarga,
        showConfirmButton: false,
        timer: 1500
      })
    })
  }

  onLinkClick(event: MatTabChangeEvent) {
    if(event.index==0){
    this.portalValidacion=false;
    }
    if(event.index==1){
      this.portalValidacion=true;

    }
  }

  getInfoEmpresa(){
    let idEmpresa: string;
    this.conteosService.getInfoEmpresa().subscribe((data:backInter.infoEmpresa) => {
      console.log("data",data);

        this.datosEmp = data;
        console.log(this.datosEmp);
        this.nombreEmpresaFinal=this.datosEmp.data.nombreEmpresa;
        console.log(this.nombreEmpresaFinal);
      }, error  => {
        console.log("error get info empresa");
      });
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      // console.log(this.mensajesTraducirKeys[iter]);

      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
  this.idiomaActual = this.translateSrv.currentLang;
    // switch(this.translateSrv.currentLang){
    //   case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
    //   default: this.idiomaActual = 'en';
    // }
  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    // console.log(institutoAct);
    if(institutoAct == '0' && localStorage.getItem('Surveystaus_portal')== "activo"){
      institutoAct = ''+localStorage.getItem('instituto_id');

      console.log("Entro a esta "+institutoAct);
      console.log(localStorage.getItem('instituto_id'));
    }
    console.log("instituto "+institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX';break;
      case '2': case 'CAyC': this.instituto = 'CAyC';break;
      case '3': case 'HK': this.instituto = 'HK';break;
      case '4': case 'SGP': this.instituto = 'SGP'; break;
      case '5': case 'TK': this.instituto = 'TK';break;
      case '6': case 'FL': this.instituto = 'FL';break;
      case '11': case 'BR': this.instituto = 'BR';break;
      case '8': case 'IZZI': this.instituto = 'IZZI';break;
    }
    console.log("Instituo "+this.instituto);
    this.getStatusCierre();
  }
  showUsers:boolean=false;

  getStatusCierre(){
    console.log("Dude");
    console.log(this.tipoProducto);
    let data:any = {};
    switch(this.tipoProducto){
      case "1": data.productoId = localStorage.getItem('productoID');
        let texto='PORTAL.PRODUCTO.CERT';
        this.translateSrv.get(texto).subscribe((res: string) => { texto= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {
          this.urlProducto = '/certify';
          console.log("acceso pantalla landing");


        }else{
          this.urlProducto = '/certify/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }

        this.fxFlexEspacio=15;
        this.avanceCertificar(data);
        this.tipoProductoFinal= texto;
        console.log(this.tipoProductoFinal);
        this.showUsers=true;

        this.fechaProducto=localStorage.getItem('fechaProducto');
        if(localStorage.getItem('Surveystaus_portal')== "activo"){
          switch(localStorage.getItem('instituto_Empresa')){
            case '1': case 'MX': this.instituto = 'MX';break;
            case '2': case 'CAyC': this.instituto = 'CAyC';break;
            case '3': case 'HK': this.instituto = 'HK';break;
            case '4': case 'SGP': this.instituto = 'SGP'; break;
            case '5': case 'TK': this.instituto = 'TK';break;
            case '6': case 'FL': this.instituto = 'FL';break;
            case '11': case 'BR': this.instituto = 'BR';break;
            case '8': case 'IZZI': this.instituto = 'IZZI';break;
          }
          console.log('this.instituto',this.instituto);
          this.statusMostrarResuCerti(this.instituto);
        }else{
          this.statusMostrarResuCerti(this.instituto);

        }

      break;
      case "c1":
        console.log("entro Portal Conteos certificar 2.0");
        data.productoId = localStorage.getItem('productoID');
        let texto1='PORTAL.PRODUCTO.CERT';
        this.translateSrv.get(texto1).subscribe((res: string) => { texto1= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {
          this.urlProducto = '/certify_t1';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = '/certify_t1/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }
        this.fxFlexEspacio=15;
        this.avanceCertificar(data);
        this.tipoProductoFinal= texto1;
        console.log(this.tipoProductoFinal);
        this.fechaProducto=localStorage.getItem('fechaProducto');
        if(localStorage.getItem('Surveystaus_portal')== "activo"){
          switch(localStorage.getItem('instituto_Empresa')){
            case '1': case 'MX': this.instituto = 'MX';break;
            case '2': case 'CAyC': this.instituto = 'CAyC';break;
            case '3': case 'HK': this.instituto = 'HK';break;
            case '4': case 'SGP': this.instituto = 'SGP'; break;
            case '5': case 'TK': this.instituto = 'TK';break;
            case '6': case 'FL': this.instituto = 'FL';break;
            case '11': case 'BR': this.instituto = 'BR';break;
            case '8': case 'IZZI': this.instituto = 'IZZI';break;
          }
          console.log('this.instituto',this.instituto);
          this.statusMostrarResuCerti(this.instituto);
        }else{
          this.statusMostrarResuCerti(this.instituto);

        }
      break;
      case "c2":
        console.log("Case 2 madafaka");
        data.productoId = localStorage.getItem('productoID');

        let textoc2='PORTAL.PRODUCTO.CERT';
        this.translateSrv.get(textoc2).subscribe((res: string) => { textoc2= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = '/certify_t2';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = '/certify_t2/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }


        this.fxFlexEspacio=15;
        this.avanceCertificar(data);
        this.tipoProductoFinal= textoc2;
        console.log(this.tipoProductoFinal);
        this.fechaProducto=localStorage.getItem('fechaProducto');
        if(localStorage.getItem('Surveystaus_portal')== "activo"){
          switch(localStorage.getItem('instituto_Empresa')){
            case '1': case 'MX': this.instituto = 'MX';break;
            case '2': case 'CAyC': this.instituto = 'CAyC';break;
            case '3': case 'HK': this.instituto = 'HK';break;
            case '4': case 'SGP': this.instituto = 'SGP'; break;
            case '5': case 'TK': this.instituto = 'TK';break;
            case '6': case 'FL': this.instituto = 'FL';break;
            case '11': case 'BR': this.instituto = 'BR';break;
            case '8': case 'IZZI': this.instituto = 'IZZI';break;
          }
          console.log('this.instituto',this.instituto);
          this.statusMostrarResuCerti(this.instituto);
        }else{
          this.statusMostrarResuCerti(this.instituto);

        }
      break;
      case "c3":
        console.log("Case 2 madafaka");
        console.log("entro Portal Conteos certificar 3.0");
        data.productoId = localStorage.getItem('productoID');

        let textoc3='PORTAL.PRODUCTO.CERT';
        this.translateSrv.get(textoc3).subscribe((res: string) => { textoc3= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = '/certify_t3';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = '/certify_t3/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }


        this.fxFlexEspacio=15;
        this.avanceCertificar(data);
        this.tipoProductoFinal= textoc3;
        console.log(this.tipoProductoFinal);
        this.fechaProducto=localStorage.getItem('fechaProducto');
        if(localStorage.getItem('Surveystaus_portal')== "activo"){
          switch(localStorage.getItem('instituto_Empresa')){
            case '1': case 'MX': this.instituto = 'MX';break;
            case '2': case 'CAyC': this.instituto = 'CAyC';break;
            case '3': case 'HK': this.instituto = 'HK';break;
            case '4': case 'SGP': this.instituto = 'SGP'; break;
            case '5': case 'TK': this.instituto = 'TK';break;
            case '6': case 'FL': this.instituto = 'FL';break;
            case '11': case 'BR': this.instituto = 'BR';break;
            case '8': case 'IZZI': this.instituto = 'IZZI';break;
          }
          console.log('this.instituto',this.instituto);
          this.statusMostrarResuCerti(this.instituto);
        }else{
          this.statusMostrarResuCerti(this.instituto);

        }
      break;
      case "c6":
        console.log("Case 2 madafaka");
        console.log("entro Portal Conteos certificar 3.0");
        data.productoId = localStorage.getItem('productoID');

        let textoc6='PORTAL.PRODUCTO.GPTW_GCTI';
        this.translateSrv.get(textoc6).subscribe((res: string) => { textoc6= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = '/certify_t6';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = '/certify_t6/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }


        this.fxFlexEspacio=15;
        this.avanceCertificar(data);
        this.tipoProductoFinal= textoc6;
        console.log(this.tipoProductoFinal);
        this.fechaProducto=localStorage.getItem('fechaProducto');
        if(localStorage.getItem('Surveystaus_portal')== "activo"){
          switch(localStorage.getItem('instituto_Empresa')){
            case '1': case 'MX': this.instituto = 'MX';break;
            case '2': case 'CAyC': this.instituto = 'CAyC';break;
            case '3': case 'HK': this.instituto = 'HK';break;
            case '4': case 'SGP': this.instituto = 'SGP'; break;
            case '5': case 'TK': this.instituto = 'TK';break;
            case '6': case 'FL': this.instituto = 'FL';break;
            case '11': case 'BR': this.instituto = 'BR';break;
            case '8': case 'IZZI': this.instituto = 'IZZI';break;
          }
          console.log('this.instituto',this.instituto);
          this.statusMostrarResuCerti(this.instituto);
        }else{
          this.statusMostrarResuCerti(this.instituto);

        }
      break;
      case "p1":
        console.log("Case 2 madafaka");
        console.log("entro Portal Conteos certificar 3.0");
        data.productoId = localStorage.getItem('productoID');

        let textop1='PORTAL.PRODUCTO.PULSE';
        this.translateSrv.get(textop1).subscribe((res: string) => { textop1= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = '/pulse_t1/adminpulsecheck';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = '/pulse_t1/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }


        this.fxFlexEspacio=15;
        this.avanceCertificar(data);
        this.tipoProductoFinal= textop1;
        console.log(this.tipoProductoFinal);
        this.fechaProducto=localStorage.getItem('fechaProducto');
        if(localStorage.getItem('Surveystaus_portal')== "activo"){
          switch(localStorage.getItem('instituto_Empresa')){
            case '1': case 'MX': this.instituto = 'MX';break;
            case '2': case 'CAyC': this.instituto = 'CAyC';break;
            case '3': case 'HK': this.instituto = 'HK';break;
            case '4': case 'SGP': this.instituto = 'SGP'; break;
            case '5': case 'TK': this.instituto = 'TK';break;
            case '6': case 'FL': this.instituto = 'FL';break;
            case '11': case 'BR': this.instituto = 'BR';break;
            case '8': case 'IZZI': this.instituto = 'IZZI';break;
          }
          console.log('this.instituto',this.instituto);
          this.statusMostrarResuCerti(this.instituto);
        }else{
          this.statusMostrarResuCerti(this.instituto);

        }
      break;
      case "f1":
        console.log("Case f1 focus area");
        console.log("entro Portal Conteos certificar 3.0");
        data.productoId = localStorage.getItem('productoID');

        let textof1='PORTAL.PRODUCTO.FOCUS';
        this.translateSrv.get(textof1).subscribe((res: string) => { textof1= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = '/focus_t1';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = '/focus_t1/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }


        this.fxFlexEspacio=15;
        this.avanceCertificar(data);
        this.tipoProductoFinal= textof1;
        console.log(this.tipoProductoFinal);
        this.fechaProducto=localStorage.getItem('fechaProducto');
        if(localStorage.getItem('Surveystaus_portal')== "activo"){
          switch(localStorage.getItem('instituto_Empresa')){
            case '1': case 'MX': this.instituto = 'MX';break;
            case '2': case 'CAyC': this.instituto = 'CAyC';break;
            case '3': case 'HK': this.instituto = 'HK';break;
            case '4': case 'SGP': this.instituto = 'SGP'; break;
            case '5': case 'TK': this.instituto = 'TK';break;
            case '6': case 'FL': this.instituto = 'FL';break;
            case '11': case 'BR': this.instituto = 'BR';break;
            case '8': case 'IZZI': this.instituto = 'IZZI';break;
          }
          console.log('this.instituto',this.instituto);
          this.statusMostrarResuCerti(this.instituto);
        }else{
          this.statusMostrarResuCerti(this.instituto);

        }
      break;
      //CGO EXPRESS
      case "CGOX":
        data.productoId = localStorage.getItem('productoID');
        let nombreProdCGOX = this.translateSrv.instant('PORTAL.PRODUCTO.CGOX');
        this.urlProducto = 'regresar';
        this.fxFlexEspacio=15;
        this.avanceCertificar(data);
        this.tipoProductoFinal= nombreProdCGOX;
        this.fechaProducto=localStorage.getItem('fechaProducto');
        if(localStorage.getItem('Surveystaus_portal')== "activo"){
          switch(localStorage.getItem('instituto_Empresa')){
            case '1': case 'MX': this.instituto = 'MX';break;
            case '2': case 'CAyC': this.instituto = 'CAyC';break;
            case '3': case 'HK': this.instituto = 'HK';break;
            case '4': case 'SGP': this.instituto = 'SGP'; break;
            case '5': case 'TK': this.instituto = 'TK';break;
            case '6': case 'FL': this.instituto = 'FL';break;
            case '11': case 'BR': this.instituto = 'BR';break;
            case '8': case 'IZZI': this.instituto = 'IZZI';break;
          }
          console.log('this.instituto',this.instituto);
          this.statusMostrarResuCerti(this.instituto);
        }else{
          this.statusMostrarResuCerti(this.instituto);

        }
      break;


      case "m7":
        console.log("Case 2 madafaka");
        console.log("entro Portal Conteos certificar 3.0");
        data.productoId = localStorage.getItem('productoID');

        let textom7='PORTAL.PRODUCTO.MEDIR_1';
        this.translateSrv.get(textom7).subscribe((res: string) => { textom7= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = '/measurement_t7';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = '/measurement_t7/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }


        this.fxFlexEspacio=15;
        this.avanceCertificar(data);
        this.tipoProductoFinal= textom7;
        console.log(this.tipoProductoFinal);
        this.fechaProducto=localStorage.getItem('fechaProducto');
        if(localStorage.getItem('Surveystaus_portal')== "activo"){
          switch(localStorage.getItem('instituto_Empresa')){
            case '1': case 'MX': this.instituto = 'MX';break;
            case '2': case 'CAyC': this.instituto = 'CAyC';break;
            case '3': case 'HK': this.instituto = 'HK';break;
            case '4': case 'SGP': this.instituto = 'SGP'; break;
            case '5': case 'TK': this.instituto = 'TK';break;
            case '6': case 'FL': this.instituto = 'FL';break;
            case '11': case 'BR': this.instituto = 'BR';break;
            case '8': case 'IZZI': this.instituto = 'IZZI';break;
          }
          console.log('this.instituto',this.instituto);
          this.statusMostrarResuCerti(this.instituto);
        }else{
          this.statusMostrarResuCerti(this.instituto);

        }
      break;
      case "2": data.productoId = localStorage.getItem('productoID');
        let textoM='PORTAL.PRODUCTO.MED';
        this.translateSrv.get(textoM).subscribe((res: string) => { textoM= res; });

        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = '/measurement';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = 'measurement/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }
        this.avanceMedir(data);
        this.tipoProductoFinal= textoM;
        this.translateSrv.get(textoM).subscribe((res: string) => { textoM = res; });
        this.fechaProducto=localStorage.getItem('fechaProducto');
      break;
      case "3": data.productoId = localStorage.getItem('productoID'); this.avancePulse();
        let textoP='PORTAL.PRODUCTO.PULSE';
        this.translateSrv.get(textoP).subscribe((res: string) => { textoP= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {
          this.urlProducto = 'pulse/adminpulsecheck';
          console.log("acceso pantalla landing");

        }else{
          this.urlProducto = 'pulse/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }



        this.tipoProductoFinal=textoP;
        this.translateSrv.get(textoP).subscribe((res: string) => { textoP = res; });
        this.fechaProducto=localStorage.getItem('fechaProducto');

      break;
      case "4":
        // data.productoId = localStorage.getItem('productoID');
        this.avanceFocusArea();
        let textoFo='PORTAL.PRODUCTO.PULSE';
        this.translateSrv.get(textoFo).subscribe((res: string) => { textoFo= res; });
        this.urlProducto = 'focus/wizard/close';
        console.log('entro este caso');
        // this.getFiltros(); ////quitar variable
        this.tipoProductoFinal=textoFo;
        // this.translateSrv.get(textoFo).subscribe((res: string) => { textoP = res; });
        // this.fechaProducto=localStorage.getItem('fechaProducto');

      break;

      case "5": data.productoId = localStorage.getItem('productoID');
        console.log("Entro "+data.productoId);
        let textoN='PORTAL.PRODUCTO.NOM35';
        this.translateSrv.get(textoN).subscribe((res: string) => { textoN= res; });
        this.urlProducto = 'NOM35-ENC/wizard-enc/cierre-n35';
        this.info=this.serviceNom.getinfo();
        this.avanceNorma35(data.productoId);
        this.tipoProductoFinal= textoN;
        this.translateSrv.get(textoN).subscribe((res: string) => { textoN = res; });
        this.fechaProducto=localStorage.getItem('fechaProducto');
      break;
      case "NOM35V3": data.productoId = localStorage.getItem('productoID');
        console.log("Entro "+data.productoId);
        let textoNv3='PORTAL.PRODUCTO.NOM35';
        this.translateSrv.get(textoNv3).subscribe((res: string) => { textoNv3= res; });
        this.urlProducto = 'NOM35-ENC/wizard-enc_t3/cierre-n35';
        this.info=this.serviceNom.getinfo();
        this.avanceNorma35(data.productoId);
        this.tipoProductoFinal= textoNv3;
        this.translateSrv.get(textoNv3).subscribe((res: string) => { textoNv3 = res; });
        this.fechaProducto=localStorage.getItem('fechaProducto');
      break;
      case "m1":
        data.productoId = localStorage.getItem('productoID');
        let textoM1='PORTAL.PRODUCTO.MED';
        this.translateSrv.get(textoM1).subscribe((res: string) => { textoM1= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = 'measurement_t1/';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = 'measurement_t1/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }

        this.avanceMedir(data);
        this.tipoProductoFinal= textoM1;
        this.translateSrv.get(textoM1).subscribe((res: string) => { textoM1 = res; });
        this.fechaProducto=localStorage.getItem('fechaProducto');
      break;
      case "m2":
        data.productoId = localStorage.getItem('productoID');
        let textoM2='PORTAL.PRODUCTO.MED';
        this.translateSrv.get(textoM2).subscribe((res: string) => { textoM2= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = 'measurement_t2/';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = 'measurement_t2/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }




        this.avanceMedir(data);
        this.tipoProductoFinal= textoM2;
        this.translateSrv.get(textoM2).subscribe((res: string) => { textoM2 = res; });
        this.fechaProducto=localStorage.getItem('fechaProducto');
      break;
      case "m3":
        data.productoId = localStorage.getItem('productoID');
        let textoM3='PORTAL.PRODUCTO.MED';
        this.translateSrv.get(textoM3).subscribe((res: string) => { textoM3= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {
          this.urlProducto = 'measurement_t3/';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = 'measurement_t3/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }

        this.avanceMedir(data);
        this.tipoProductoFinal= textoM3;
        this.translateSrv.get(textoM3).subscribe((res: string) => { textoM3 = res; });
        this.fechaProducto=localStorage.getItem('fechaProducto');
      break;
      case "m4":
        data.productoId = localStorage.getItem('productoID');
        let textoM4='PORTAL.PRODUCTO.MED';
        this.translateSrv.get(textoM4).subscribe((res: string) => { textoM4= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));
        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {
          this.urlProducto = 'measurement_t4/';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = 'measurement_t4/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }
        this.avanceMedir(data);
        this.tipoProductoFinal= textoM4;
        this.translateSrv.get(textoM4).subscribe((res: string) => { textoM4 = res; });
        this.fechaProducto=localStorage.getItem('fechaProducto');
      break;
      case "m5":
        console.log("entro case m5");
        console.log(data);
        data.productoId = localStorage.getItem('productoID');
        let textoM5='PORTAL.PRODUCTO.MED';
        this.translateSrv.get(textoM5).subscribe((res: string) => { textoM5= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = 'measurement_t5/';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = 'measurement_t5/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }
        this.avanceMedir(data);
        this.tipoProductoFinal= textoM5;
        this.translateSrv.get(textoM5).subscribe((res: string) => { textoM5 = res; });
        this.fechaProducto=localStorage.getItem('fechaProducto');
      break;
      case "m6":
        console.log("entro case m6");
        console.log(data);
        data.productoId = localStorage.getItem('productoID');
        let textoM6='PORTAL.PRODUCTO.MED';
        this.translateSrv.get(textoM6).subscribe((res: string) => { textoM6= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));
        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {
          this.urlProducto = 'measurement_t6/';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = 'measurement_t6/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }
        this.avanceMedir(data);
        this.tipoProductoFinal= textoM6;
        this.translateSrv.get(textoM6).subscribe((res: string) => { textoM6 = res; });
        this.fechaProducto=localStorage.getItem('fechaProducto');
      break;
      case "am1":
        console.log("Case para el produto nuevo AMCO");
        data.productoId = localStorage.getItem('productoID');

        let textoAMCO='PORTAL.PRODUCTO.AMCO';
        this.translateSrv.get(textoAMCO).subscribe((res: string) => { textoAMCO= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = '/certify_t3';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = '/amco_1/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }


        this.fxFlexEspacio=15;
        this.avanceCertificar(data);
        this.tipoProductoFinal= textoAMCO;
        console.log(this.tipoProductoFinal);
        this.fechaProducto=localStorage.getItem('fechaProducto');
        if(localStorage.getItem('Surveystaus_portal')== "activo"){
          switch(localStorage.getItem('instituto_Empresa')){
            case '1': case 'MX': this.instituto = 'MX';break;
            case '2': case 'CAyC': this.instituto = 'CAyC';break;
            case '3': case 'HK': this.instituto = 'HK';break;
            case '4': case 'SGP': this.instituto = 'SGP'; break;
            case '5': case 'TK': this.instituto = 'TK';break;
            case '6': case 'FL': this.instituto = 'FL';break;
            case '11': case 'BR': this.instituto = 'BR';break;
            case '8': case 'IZZI': this.instituto = 'IZZI';break;
          }
          console.log('this.instituto',this.instituto);
          this.statusMostrarResuCerti(this.instituto);
        }else{
          this.statusMostrarResuCerti(this.instituto);

        }
      break;
      case "td1":
        console.log("Case para el produto nuevo AMCO");
        data.productoId = localStorage.getItem('productoID');

        let textotd1='PORTAL.PRODUCTO.TRAB_DIGN';
        this.translateSrv.get(textotd1).subscribe((res: string) => { textotd1= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = '/certify_t3';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = '/traba_digno/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }


        this.fxFlexEspacio=15;
        this.avanceCertificar(data);
        this.tipoProductoFinal= textotd1;
        console.log(this.tipoProductoFinal);
        this.fechaProducto=localStorage.getItem('fechaProducto');
        if(localStorage.getItem('Surveystaus_portal')== "activo"){
          switch(localStorage.getItem('instituto_Empresa')){
            case '1': case 'MX': this.instituto = 'MX';break;
            case '2': case 'CAyC': this.instituto = 'CAyC';break;
            case '3': case 'HK': this.instituto = 'HK';break;
            case '4': case 'SGP': this.instituto = 'SGP'; break;
            case '5': case 'TK': this.instituto = 'TK';break;
            case '6': case 'FL': this.instituto = 'FL';break;
            case '11': case 'BR': this.instituto = 'BR';break;
            case '8': case 'IZZI': this.instituto = 'IZZI';break;
          }
          console.log('this.instituto',this.instituto);
          this.statusMostrarResuCerti(this.instituto);
        }else{
          this.statusMostrarResuCerti(this.instituto);

        }
      break;
      case "pe1":
        console.log("Case para el produto nuevo AMCO");
        data.productoId = localStorage.getItem('productoID');

        let textope1='PORTAL.PRODUCTO.PRI_EMPLE';
        this.translateSrv.get(textope1).subscribe((res: string) => { textope1= res; });
        console.log(localStorage.getItem('accesoPortalLanding'));

        if (localStorage.getItem('accesoPortalLanding')=='accesoPortalLanding') {

          this.urlProducto = '/certify_t3';
          console.log("acceso pantalla landing");
        }else{
          this.urlProducto = '/prime_emple/wizard/close';
          console.log("acceso pantalla cerrar encuesta");
        }


        this.fxFlexEspacio=15;
        this.avanceCertificar(data);
        this.tipoProductoFinal= textope1;
        console.log(this.tipoProductoFinal);
        this.fechaProducto=localStorage.getItem('fechaProducto');
        if(localStorage.getItem('Surveystaus_portal')== "activo"){
          switch(localStorage.getItem('instituto_Empresa')){
            case '1': case 'MX': this.instituto = 'MX';break;
            case '2': case 'CAyC': this.instituto = 'CAyC';break;
            case '3': case 'HK': this.instituto = 'HK';break;
            case '4': case 'SGP': this.instituto = 'SGP'; break;
            case '5': case 'TK': this.instituto = 'TK';break;
            case '6': case 'FL': this.instituto = 'FL';break;
            case '11': case 'BR': this.instituto = 'BR';break;
            case '8': case 'IZZI': this.instituto = 'IZZI';break;
          }
          console.log('this.instituto',this.instituto);
          this.statusMostrarResuCerti(this.instituto);
        }else{
          this.statusMostrarResuCerti(this.instituto);

        }
      break;

      //CREAR CASOS PARA PULSECHECK Y FOCUS SI APLICARA
    }

    if(localStorage.getItem('Surveystaus_portal')== "activo"){
      // let idEmpesa_aux = localStorage.getItem('idEmpresa_surveysatus');
      // this.urlProducto = '/companies/survey-status/'+idEmpesa_aux;
      this.urlProducto = 'regresar';
      localStorage.setItem('BACK_PORTAL','Activo');
    }
    console.log(data);
  }

  avanceCertificar(data:any) {
  var moment = require('moment');
  let banderaid:boolean;
  if(localStorage.getItem('Surveystaus_portal')== "activo"){
    banderaid=true;
  }
  this.serviceCert.getAvanceEncuesta(data,banderaid).subscribe((response:backInter.portalConteos) => {
    console.log("Respuesta avance certificar");
    console.log(response);
    this.cargando = false;
    this.infoAvanceConteo=response;
    this.totalUsers=this.infoAvanceConteo.avance.totalUsers;
    this.endUsers=this.infoAvanceConteo.avance.endUsers;
    this.porcentajeUsers=this.infoAvanceConteo.avance.porcentaje;
    this.uncomplete_users=this.infoAvanceConteo.avance.logoutUsers;
    this.fechaLanzamiento= this.infoAvanceConteo.fechaLanzamiento;
    let gmtFecha=moment.parseZone(momentTz(this.fechaLanzamiento).tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log('gmtFecha',gmtFecha);
    this.calculoOffsetPipe(gmtFecha);
    this.fechaCierre= this.infoAvanceConteo.fechaCierre;
    this.respRecRes=this.infoAvanceConteo.avance.respRecRes;
    this.respMinCer=this.infoAvanceConteo.avance.respMinCer;

    console.log(this.fechaLanzamiento);
    console.log(this.fechaCierre);
    // this.sumaFormula1= this.totalUsers*((2.33*2.33)*.5*.5);
    // this.sumaFormula2= ((.03*.03)*(this.totalUsers-1))+((2.33*2.33)*.5*.5);
    // his.resultadoRanking= this.sumaFormula1/this.sumaFormula2;
    // console.log(this.sumaFormula1);
    // console.log(this.sumaFormula2);
    // console.log(this.resultadoRanking);
    this.formulasPorInstituto(this.totalUsers);
    this.timeLineCertificar();
    let fechaHoy= moment();
    let fechaLanzamiento2= moment(this.fechaCierre);

    let fechaLanzamientoEncuesta= moment(this.fechaLanzamiento);
    if(fechaHoy.isBefore(this.fechaLanzamiento)){
      this.fechaAnterior =true;
    }
        if(fechaHoy.isAfter(fechaLanzamiento2)){
          this.diasRestantes=0;
          this.progreso=100;
        }
        else{
          let totalDias= 21;
          this.diasRestantes=fechaLanzamiento2.diff(fechaHoy,'days',true);
          this.diasRestantes=Math.floor(this.diasRestantes);

          // let transcurridos= fechaLanzamientoEncuesta.diff(fechaLanzamiento1,'days');
          this.diasTranscurridos= fechaLanzamientoEncuesta.diff(fechaHoy,'days');
          console.log("Dias trancurridos",this.diasTranscurridos);
          this.progreso= (100/totalDias)*(totalDias-this.diasRestantes);
          console.log(this.progreso);
          console.log(fechaHoy.diff(fechaLanzamiento2,'days'));
        }
      this.cambiaColorProgress();

  }, error => {
    console.log("error getAvanceEncuesta");
    console.log("");
    //console.log(error);
  });
}

 formulasPorInstituto(totalUsers){
   switch (this.instituto) {
     case 'CAyC':
     this.resultadoRanking= totalUsers* 0.95;
     this.resultadoEntregables= totalUsers* 0.95;
       break;

     default:
     this.resultadoRanking= totalUsers* 0.95;
     this.resultadoEntregables= totalUsers* 0.85;

       break;
   }
   console.log('resultadoRanking ',this.resultadoRanking);
   console.log('resultadoEntregables ',this.resultadoEntregables);


 }

  avanceMedir(data:any) {
  var moment = require('moment');
  console.log("Avance medir");
  console.log(data);
  let banderaid:boolean;
  if(localStorage.getItem('Surveystaus_portal')== "activo"){
    banderaid=true;
  }
  this.serviceMed.getAvanceEncuestaMedir(data,banderaid).subscribe((response:backInter.portalConteos) => {

    this.infoAvanceConteo=response;
    this.cargando = false;
    this.totalUsers=this.infoAvanceConteo.avance.totalUsers;
    this.endUsers=this.infoAvanceConteo.avance.endUsers;
    this.porcentajeUsers=this.infoAvanceConteo.avance.porcentaje;
    this.uncomplete_users=this.infoAvanceConteo.avance.logoutUsers;
    this.fechaLanzamiento= this.infoAvanceConteo.fechaLanzamiento;
    this.fechaCierre= this.infoAvanceConteo.fechaCierre;
    this.timeLineMedir();
    let fechaLanzamiento1= moment();
    let fechaLanzamiento2= moment(this.fechaCierre);
    if(fechaLanzamiento1.isBefore(this.fechaLanzamiento)){
      this.fechaAnterior =true;
    }
    if(fechaLanzamiento1.isAfter(fechaLanzamiento2)){
      this.diasRestantes=0;
      this.progreso=100;
    }
    else{
      let totalDias= 21;
      this.diasRestantes=fechaLanzamiento2.diff(fechaLanzamiento1,'days',true);
      this.diasRestantes=Math.floor(this.diasRestantes);
      this.progreso= (100/totalDias)*(totalDias-this.diasRestantes);
      console.log(this.progreso);
      console.log(fechaLanzamiento1.diff(fechaLanzamiento2,'days'));
    }
    this.cambiaColorProgress();
    console.log(response);
  }, error => {
    console.log("Error avance medir");
    console.log(error);
  });
}

  avancePulse() {
  var moment = require('moment');
  let datos:any= {productoId: localStorage.getItem('productoID'), idSurvey: localStorage.getItem('encuestaID')};
  let banderaid:boolean;
  console.log(localStorage.getItem('Surveystaus_portal'));
  console.log(localStorage.getItem('idSurvey_status'));
  if(localStorage.getItem('Surveystaus_portal')== "activo"){
    console.log("Entro pulse");
    banderaid=true;
    datos = {productoId: localStorage.getItem('productoID'), idSurvey: localStorage.getItem('idSurvey_status')};
  }
  console.log(datos);
  console.log(datos);
  this.servicePul.getAvanceEncuestaPulse(datos,banderaid).subscribe((response:backInter.portalConteos) => {
    this.infoAvanceConteo=response;
    this.cargando = false;
    this.totalUsers=this.infoAvanceConteo.avance.totalUsers;
    this.endUsers=this.infoAvanceConteo.avance.endUsers;
    this.porcentajeUsers=this.infoAvanceConteo.avance.porcentaje;
    this.uncomplete_users=this.infoAvanceConteo.avance.logoutUsers;
    this.fechaLanzamiento= this.infoAvanceConteo.fechaLanzamiento;
    this.fechaCierre= this.infoAvanceConteo.fechaCierre;
    console.log(this.fechaLanzamiento);
    console.log(this.fechaCierre);
    this.sumaFormula1= this.totalUsers*((2.33*2.33)*.5*.5);
    this.sumaFormula2= ((.03*.03)*(this.totalUsers-1))+((2.33*2.33)*.5*.5);
    // this.resultadoRanking= this.sumaFormula1/this.sumaFormula2;
    // this.resultadoRanking= this.totalUsers*0.95;
    this.timeLinePulse();
    let fechaLanzamiento1= moment();
    let fechaLanzamiento2= moment(this.fechaCierre);
    if(fechaLanzamiento1.isBefore(this.fechaLanzamiento)){
      this.fechaAnterior =true;
    }
    if(fechaLanzamiento1.isAfter(fechaLanzamiento2)){
      this.diasRestantes=0;
      this.progreso=100;
    }
    else{
      let totalDias= 21;
      this.diasRestantes=fechaLanzamiento2.diff(fechaLanzamiento1,'days',true);
      this.diasRestantes=Math.floor(this.diasRestantes);
      this.progreso= (100/totalDias)*(totalDias-this.diasRestantes);
      console.log(this.progreso);
      console.log(fechaLanzamiento1.diff(fechaLanzamiento2,'days'));
    }
    this.cambiaColorProgress();
    console.log(response);
  }, error => {
    console.log(" error getAvanceEncuestaPulse");
    //console.log(error);
  });
}

  kindSurvey:any;
  goneUser:any;
  avanceNorma35(data:any) {

   var moment = require('moment');
   //console.log("Tipo de encuesta portal");
   //console.log(localStorage.getItem('surveytype'));
   let tipoEncuestaTmp=localStorage.getItem('surveytype');


 // Más de 50 es 0 y menos de 50 es 1
     let banderaid:boolean;
     if(localStorage.getItem('Surveystaus_portal')== "activo"){
       banderaid=true;
     }
   this.serviceNom.getAvanceNorma(data,localStorage.getItem('surveytype'),banderaid).subscribe((response:backInter.surveyprogress) => {
     this.cargandoTablaFiltros=false;
      let tipoEncuesta=localStorage.getItem('surveytype');
      this.cargando = false;
      console.log("Tipo de encuesta "+tipoEncuesta);
      console.log("NUEVA RESPUESTA ENCUESTA",response);
      this.tmp=response.avance;
      this.statusNorma=true;
      this.portalValidacion=true;
      this.totalUsers=this.tmp.totalUsers;
      this.endUsers=this.tmp.endUsers;
      this.goneUser=this.tmp.usersGone;
      //this.porcentajeUsers=this.tmp.porcentaje;
      console.log("Prueba fechas temporales");
      console.log(response.fechaLanzamiento);
      console.log(response.fechaCierre);
      console.log('this.tipoProducto',this.tipoProducto);
      if (this.tipoProducto!="NOM35V3") {
        this.fechaLanzamiento =  response.fechaLanzamiento;
        this.fechaCierre = response.fechaCierre;
      }else{
        this.fechaLanzamiento =  this.datePipe.transform(new Date(response.fechaLanzamiento),'d MMM y',this.offsetPipe);
        this.fechaCierre =  this.datePipe.transform(new Date(response.fechaCierre),'d MMM y',this.offsetPipe);
      }
      console.log('this.fechaLanzamiento',this.fechaLanzamiento);
      console.log('this.fechaCierre',this.fechaCierre);

  // EL 0 ES MÁS DE 50 Y EL 1 MENOS DE 50
   if(tipoEncuesta=="1"){
    console.log("Ha entrado a la númerp 1");
    console.log(this.fechaLanzamiento);
    console.log(this.fechaCierre);
     this.banderaencuesta35=1;
     this.uncomplete_users=this.tmp.logoutUsers;
     this.resultadoRanking=0.9604*(this.totalUsers)/(0.0025*(this.totalUsers-1)+0.9604);
     this.timeLineNorma35();
     let fechaHoy= moment();
     let fechaLanzamiento2= moment(response.fechaCierre);

     let fechaLanzamientoEncuesta= moment(this.fechaLanzamiento);
     if(fechaHoy.isBefore(this.fechaLanzamiento)){
       this.fechaAnterior =true;
     }
         if(fechaHoy.isAfter(fechaLanzamiento2)){
           this.diasRestantes=0;
           this.progreso=100;
         }
         else{
           let totalDias= 21;
           this.diasRestantes=fechaLanzamiento2.diff(fechaHoy,'days',true);
           this.diasRestantes=Math.floor(this.diasRestantes);

           // let transcurridos= fechaLanzamientoEncuesta.diff(fechaLanzamiento1,'days');
           this.diasTranscurridos= fechaLanzamientoEncuesta.diff(fechaHoy,'days');
           console.log("Dias trancurridos",this.diasTranscurridos);
           this.progreso= (100/totalDias)*(totalDias-this.diasRestantes);
           console.log(this.progreso);
           console.log(fechaHoy.diff(fechaLanzamiento2,'days'));
         }
         this.porcentajeUsers=this.totalUsers;
       this.cambiaColorProgress();
   }else if(tipoEncuesta=="0"){
     this.banderaencuesta35=0;
     this.uncomplete_users=this.tmp.logoutUsers;
     this.resultadoRanking=0.9604*(this.totalUsers)/(0.0025*(this.totalUsers-1)+0.9604);
     this.timeLineNorma35();
     let fechaHoy= moment();
     let fechaLanzamiento2= moment(response.fechaCierre);
     console.log("fechaLanzamientoCierren++++++++++++++",this.fechaCierre);


     let fechaLanzamientoEncuesta= moment(this.fechaLanzamiento);
     if(fechaHoy.isBefore(this.fechaLanzamiento)){
       this.fechaAnterior =true;
     }
         if(fechaHoy.isAfter(fechaLanzamiento2)){
           this.diasRestantes=0;
           this.progreso=100;
         }
         else{
           let totalDias= 21;
           this.diasRestantes=moment(fechaLanzamiento2).diff(fechaHoy,'days',true);
           this.diasRestantes=Math.floor(this.diasRestantes);

           // let transcurridos= fechaLanzamientoEncuesta.diff(fechaLanzamiento1,'days');
           this.diasTranscurridos= fechaLanzamientoEncuesta.diff(fechaHoy,'days');
           console.log("Dias trancurridos",this.diasTranscurridos);
           this.progreso= (100/totalDias)*(totalDias-this.diasRestantes);
           console.log(this.progreso);
           console.log(fechaHoy.diff(fechaLanzamiento2,'days'));
         }
     this.porcentajeUsers=0.9604*(this.totalUsers)/(0.0025*(this.totalUsers-1)+0.9604);
     this.porcentajeUsers=this.porcentajeUsers.toFixed(2);

     this.cambiaColorProgress();

   }

   this.getWorkscenter();
   this.getFiltros35();
   this.cargandoTablaFiltros= false;

   }, error => {
     console.log("error getAvanceNorma");
   //console.log(error);
   });
}

avanceFocusArea() {
var moment = require('moment');
  this.serviceFoc.getAvanceEncuesta().subscribe((response:backInter.portalConteos) => {
    console.log("Respuesta avance certificar");
    console.log(response);
    this.cargando = false;
    this.infoAvanceConteo=response;
    this.totalUsers=this.infoAvanceConteo.avance.totalUsers;
    this.endUsers=this.infoAvanceConteo.avance.endUsers;
    this.porcentajeUsers=this.infoAvanceConteo.avance.porcentaje;
    this.uncomplete_users=this.infoAvanceConteo.avance.logoutUsers;
    this.fechaLanzamiento= this.infoAvanceConteo.fechaLanzamiento;
    this.fechaCierre= this.infoAvanceConteo.fechaCierre;
    console.log(this.fechaLanzamiento);
    console.log(this.fechaCierre);
    this.sumaFormula1= this.totalUsers*((2.33*2.33)*.5*.5);
    this.sumaFormula2= ((.03*.03)*(this.totalUsers-1))+((2.33*2.33)*.5*.5);
    // this.resultadoRanking= this.sumaFormula1/this.sumaFormula2;
    // this.resultadoRanking= this.totalUsers*0.95;
    // console.log(this.sumaFormula1);
    // console.log(this.sumaFormula2);
    // console.log(this.resultadoRanking);

    this.timeLineFocusArea();
    let fechaLanzamiento1= moment();
    let fechaLanzamiento2= moment(this.fechaCierre);
    if(fechaLanzamiento1.isBefore(this.fechaLanzamiento)){
      this.fechaAnterior =true;
    }
    if(fechaLanzamiento1.isAfter(fechaLanzamiento2)){
      this.diasRestantes=0;
      this.progreso=100;
    }
    else{
      let totalDias= 21;
      this.diasRestantes=fechaLanzamiento2.diff(fechaLanzamiento1,'days',true);
      this.diasRestantes=Math.floor(this.diasRestantes);
      this.progreso= (100/totalDias)*(totalDias-this.diasRestantes);
      console.log(this.progreso);
      console.log(fechaLanzamiento1.diff(fechaLanzamiento2,'days'));
    }
    this.cambiaColorProgress();
  }, error => {
    console.log("error getAvanceEncuesta");
    //console.log(error);
  });
}


  getFiltros() {
    let dato={institutoId:this.IdInstituto};
    if(localStorage.getItem('Surveystaus_portal')== "activo"){
      dato={institutoId: parseInt(localStorage.getItem('instituto_id'))}
    }

    this.conteosService.getListaFiltros(dato).subscribe((respuesta:backInter.getListaFiltros) => {
      console.log("Filtros");
      console.log(respuesta);
      this.listaFiltros = respuesta.filtros;
    }, error => {
      console.log(error);
      console.log("getListaFiltros");
    });
  }

  getFiltros35(){
    //
    console.log("Filtros norma 35");
    this.conteoservice35.getfiltroNorma().subscribe((respuesta:backInter.getListaFiltros) => {
      //console.log("Respuesta");
      console.log(respuesta);
      this.listaFiltros = respuesta.filtros;
      //console.log(this.listaFiltros);
    }, error => {
      console.log(error);
      console.log("error getfiltroNorma");
    });
  }

  Array_muestra:any[]=[];
  Array_Log:any[]=[];
  Array_gone:any[]=[];
  Tmp: any = [];
  muestra:any;
  statusFiltroCT:boolean=false;

  getConteosF(dato: number, nombre:string) {
     this.idFiltro=dato;
    this.tipoProducto = localStorage.getItem('tipoProducto');
    this.translateSrv.get('PORTAL.FILTROS.'+dato).subscribe((res1: string) => { this.nombre = res1; });
    this.translateSrv.get('PORTAL35.FILTROS.'+dato).subscribe((res1: string) => { this.nombre35 = res1; });
    let idproducto= localStorage.getItem('productoID');
    let idfiltro= dato;
    let datos:any = {productoId:idproducto, filtroId:idfiltro };
    //PULSECHECK
    let idEncuesta=localStorage.getItem('encuestaID');
    let data:any = {productoId:idproducto,filtroId:idfiltro, encuestaId:idEncuesta};
    this.cargandoFiltros=true;
    this.mensaje=false;
    console.log("Conteos");
    console.log(this.tipoProducto);
    switch(this.tipoProducto){
      case "1":
      console.log(datos);
      this.conteosService.getConteoFiltro(datos).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;

      } else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }


      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;
      case "c1":
      console.log(datos);
      this.conteosService.getConteoFiltro(datos).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;

      } else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }


      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;
      case "c2":
      console.log("Case 2 de filtros");
      console.log(datos);
      this.conteosService.getConteoFiltro(datos).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;

      } else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }


      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;
      case "c3":
      console.log("Case 2 de filtros");
      console.log(datos);
      this.conteosService.getConteoFiltro(datos).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;

      } else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }


      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;
      case "p1":
      console.log("Case 2 de filtros");
      console.log(datos);
      this.conteosService.getConteoFiltro(datos).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;

      } else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }


      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;
      case "f1":
      console.log("Case focus de filtros");
      console.log(datos);
      this.conteosService.getConteoFiltro(datos).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;

      } else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }


      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;
      case "m7":
      console.log("Case 2 de filtros");
      console.log(datos);
      this.conteosService.getConteoFiltro(datos).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;

      } else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }


      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;
      case "am1":
      console.log("Case 2 de filtros");
      console.log(datos);
      this.conteosService.getConteoFiltro(datos).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;

      } else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }


      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;
      case "td1":
      console.log("Case 2 de filtros");
      console.log(datos);
      this.conteosService.getConteoFiltro(datos).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;

      } else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }


      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;
      case "pe1":
      console.log("Case 2 de filtros");
      console.log(datos);
      this.conteosService.getConteoFiltro(datos).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;

      } else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }


      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;
      case "2":
      console.log(datos);
      this.conteosService.getConteoFiltroMedir(datos).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        if(respuesta.resultado.length >0){
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;
      }
      else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }
      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;
      case "m1": case "m2": case "m3": case "m4": case "m5": case "m6":
        console.log("Conteos filtro m2");
        console.log(datos);
        this.conteosService.getConteoFiltroMedir(datos).subscribe((respuesta: backInter.getConteosFiltros) => {
          console.log(respuesta);
          //this.resultadoConteo = respuesta;
          //this.cargandoFiltros=false;
          if(respuesta.resultado.length >0){
            this.resultadoConteo = respuesta;
            this.cargandoFiltros=false;
          }
          else{
            console.log("no tiene nada ");
            this.cargandoFiltros=false;
            this.mensaje=true;
          }
        }, error => {
          console.log(" error getConteoFiltro");
          console.log(error);
        });

      break;
      case "3":
      console.log(data);
      this.conteosService.getConteoFiltroPulse(data).subscribe((respuesta: backInter.getConteosFiltros) => {
        if(respuesta.resultado.length >0){
          this.resultadoConteo = respuesta;
          this.cargandoFiltros=false;
        }
      else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }
      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;
      case "4":
      let infoFocus:any = {filtroId:idfiltro};
      console.log(data);
      this.conteosService.getConteoFiltroFocusArea(infoFocus).subscribe((respuesta: backInter.getConteosFiltros) => {
        if(respuesta.resultado.length >0){
          this.resultadoConteo = respuesta;
          this.cargandoFiltros=false;
        }
      else{
        console.log("no tiene nada ");
      this.cargandoFiltros=false;
      this.mensaje=true;
      }
      }, error => {
        console.log(" error getConteoFiltro");
        console.log(error);
      });
      break;

      case "5":
        console.log("Entro conteo norma");
      let data35={
        productoId : localStorage.getItem('productoID'),
        tipoEncuesta :   this.banderaencuesta35,
        centroId : this.idCt,
        filtroId : this.idFiltro
      }
      let banderaid:boolean;
       if(localStorage.getItem('Surveystaus_portal')== "activo"){
         banderaid=true;
       }
      this.serviceNom.getConteoNorma(data35,banderaid).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;
        console.log('portalValidacion',this.portalValidacion);

        if(respuesta.resultado.length == 0){
          this.mensaje=true;
        }else{
          if(dato==1){
            this.statusFiltroCT=true;
            console.log('Entro hasta aqui ');

            for(let i=0; i< respuesta.resultado.length; i++){
              var dataAux:any[]=[];
              var dataAuxLOG:any[]=[];
              var dataGone:any[]=[];
              this.Array_muestra.push(dataAux);
              this.Array_Log.push(dataAuxLOG);
              this.Array_gone.push(dataGone);
            }
            for(let i=0; i< respuesta.resultado.length; i++){
              if(this.resultadoConteo.resultado[i].totalUsers < 50){
                this.muestra = this.resultadoConteo.resultado[i].totalUsers;
              }else{
                this.muestra=0.9604*(this.resultadoConteo.resultado[i].totalUsers)/(0.0025*(this.resultadoConteo.resultado[i].totalUsers-1)+0.9604);
              }
              if(this.resultadoConteo.resultado[i].logoutUsers){
                this.Array_Log[i]=this.resultadoConteo.resultado[i].logoutUsers;
              }else{
                this.Array_Log[i]=0;
              }
              if(this.resultadoConteo.resultado[i].usersGone){
                this.Array_gone[i]=this.resultadoConteo.resultado[i].usersGone;
              }else{
                this.Array_gone[i]=0;
              }
              this.Array_muestra[i]=this.muestra.toFixed(2);
            }
          }else{
            this.statusFiltroCT=false;
          }
        }
      }, error => {
        console.log(" error getConteoNorma");
        console.log(error);
      });
      break;
      case "NOM35V3":
        console.log("Entro conteo norma");
      let data35v3={
        productoId : localStorage.getItem('productoID'),
        tipoEncuesta :   this.banderaencuesta35,
        centroId : this.idCt,
        filtroId : this.idFiltro
      }
      let banderaidv3:boolean;
       if(localStorage.getItem('Surveystaus_portal')== "activo"){
         banderaidv3=true;
       }
      this.serviceNom.getConteoNorma(data35v3,banderaidv3).subscribe((respuesta: backInter.getConteosFiltros) => {
        console.log(respuesta);
        this.resultadoConteo = respuesta;
        this.cargandoFiltros=false;
        console.log('portalValidacion',this.portalValidacion);

        if(respuesta.resultado.length == 0){
          this.mensaje=true;
        }else{
          if(dato==1){
            this.statusFiltroCT=true;
            console.log('Entro hasta aqui ');

            for(let i=0; i< respuesta.resultado.length; i++){
              var dataAux:any[]=[];
              var dataAuxLOG:any[]=[];
              var dataGone:any[]=[];
              this.Array_muestra.push(dataAux);
              this.Array_Log.push(dataAuxLOG);
              this.Array_gone.push(dataGone);
            }
            for(let i=0; i< respuesta.resultado.length; i++){
              if(this.resultadoConteo.resultado[i].totalUsers < 50){
                this.muestra = this.resultadoConteo.resultado[i].totalUsers;
              }else{
                this.muestra=0.9604*(this.resultadoConteo.resultado[i].totalUsers)/(0.0025*(this.resultadoConteo.resultado[i].totalUsers-1)+0.9604);
              }
              if(this.resultadoConteo.resultado[i].logoutUsers){
                this.Array_Log[i]=this.resultadoConteo.resultado[i].logoutUsers;
              }else{
                this.Array_Log[i]=0;
              }
              if(this.resultadoConteo.resultado[i].usersGone){
                this.Array_gone[i]=this.resultadoConteo.resultado[i].usersGone;
              }else{
                this.Array_gone[i]=0;
              }
              this.Array_muestra[i]=this.muestra.toFixed(2);
            }
          }else{
            this.statusFiltroCT=false;
          }
        }
      }, error => {
        console.log(" error getConteoNorma");
        console.log(error);
      });
      break;
    }
  }


  cambiaColorProgress() {
    const head = document.getElementsByTagName('head')[0];
    let css='';
    css = css+`
    .prro .mat-progress-bar-fill::after {
      background-color: #28a745 !important;
    }
    .izzi .mat-progress-bar-fill::after {
      background-color: #25b7b3 !important;
    }
    .gcti .mat-progress-bar-fill::after {
      background-color: #960EBD !important;
    }
    body.temaFocusArea2 .mat-progress-bar-background{
      fill: #97C284 !important;
    }`;

    if(this.progreso >0 && this.progreso<50){
      css = css+`
      .barcolor .mat-progress-bar-fill::after {
        background-color: #28a745 !important;
      }

      .barcolorIzzi .mat-progress-bar-fill::after {
        background-color: #25b7b3 !important;
      }

      .barcolorGCTI .mat-progress-bar-fill::after {
        background-color: #960EBD !important;
      }

      body.temaFocusArea2 .mat-progress-bar-background{
        fill: #D6D7D8 !important;
      }`;
    };
    if(this.progreso >=50 && this.progreso <=70){
      css = css+`
      .barcolor .mat-progress-bar-fill::after {
        background-color:#ffc107 !important;
      }
      body.temaFocusArea2 .mat-progress-bar-background{
        fill: #D6D7D8 !important;
      }`;
    };
    if(this.progreso >=71 && this.progreso ==100){
      css = css+`
      .barcolor .mat-progress-bar-fill::after {
        background-color: #FC150E !important;
      }
      body.temaFocusArea2 .mat-progress-bar-background{
        fill: #D6D7D8 !important;
      }`;
    };

    this.styleElement.innerHTML = '';
    this.styleElement.type = 'text/css';
    this.styleElement.appendChild(document.createTextNode(css));
    head.appendChild(this.styleElement);

  }


  getWorkscenter(){


    let fecha35:any = this.tipoProducto == 'NOM35V3' ? localStorage.getItem('FechaNorma'): localStorage.getItem('fechaProducto');
    // let fecha35:any = localStorage.getItem('fechaProducto');
    let banderaid:boolean;
    if(localStorage.getItem('Surveystaus_portal')== "activo"){
      banderaid=true;
    }
    console.log(fecha35);
    this.serviceNom.getInfoCentrosTmp(fecha35,banderaid).subscribe( (resu2:backInter.getInfoCentros) => {
      console.log(resu2);
      this.tipoEncuesta=localStorage.getItem('surveytype');
      this.centrosTrabajo = resu2.centros;
      console.log("Centros de trabajo");
      console.log(this.centrosTrabajo);
      for(let j=0; j <  this.centrosTrabajo.length; j++){
        if(this.tipoEncuesta == 1){
          if(this.centrosTrabajo[j].totalColaboradores < 50){
            this.centrosTrabajoTmp.push(this.centrosTrabajo[j]);
          }
        }else if(this.tipoEncuesta == 0){
          if(this.centrosTrabajo[j].totalColaboradores >= 50){
            this.centrosTrabajoTmp.push(this.centrosTrabajo[j]);
          }
        }
      }
      this.centrosTrabajo=this.centrosTrabajoTmp;

    },error=>{
      console.log("error getInfoCentrosTmp");
    });

  }

  getCT_info(idCt,nombreCT){
    this.selectType = false;
    this.idCt=idCt;
    this.nombreCT= nombreCT;
    this.estatusCT=false;

  }





  exportarExcel(){
    let data={productoId: localStorage.getItem('productoID')}
    this.conteosService.getInfoDescargaExcelCertificar(data).subscribe((data: any) => {
      console.log(data);
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Descarga Correctamente',
        showConfirmButton: false,
        timer: 1500
      })
      }, error => {
        console.log("error exportarExcel()");
        console.log(error);
    });
  }


  timeLineCertificar(){

    this.conteosService.getTimeLineGraficaCertificar().subscribe((data: backInter.timeLineGraficaCertificar) => {
      console.log("Respuesta del timeline");
      console.log(data);
     // this.getFiltros();
      let datas:any[]=[];
      let i=0;
      let labelsFechas:any[]=[];
      let valorMayor: any[]=[];
      let labelsFechasLine:any[]=[];
      let valorMayorLine: any[]=[];
      data.resultado.forEach(element => {
        let objeto={x:0, y:0,r:0};
        objeto.x=i;
        objeto.y=element.endUsers;
        objeto.r=6;
        datas.push(objeto);
        labelsFechas.push(element.fecha);
        valorMayor.push(element.endUsers);

        i++;
      });

      data.resultado.forEach(element => {
        // labelsFechasLine.push(element.fecha);
        labelsFechasLine.push(this.datePipe.transform(new Date(element.fecha),'d MMM y','+0000',this.idiomaActual));
        valorMayorLine.push(element.endUsers);

        i++;
      });

      this.lineChartData[0].data=valorMayorLine;
      this.lineChartLabels=labelsFechasLine;
      console.log('this.lineChartLabels',this.lineChartLabels);

      console.log(this.lineChartData);
      this.graficaValoresLine(labelsFechasLine);
      this.graficaValores(labelsFechas,valorMayor,labelsFechas.length);


      this.bubbleChartData[0].data = datas;
      console.log(this.bubbleChartData);
      this.datosEncontrados=true;
      this.timeLineGraficaCer = data;
      // console.log(this.timeLineGraficaCer);

      // this.cargandoFiltros=false;
    }, error => {
      console.log("error getTimeLineGraficaCertificar");
      console.log(error);
    });



  }

  timeLineMedir(){
    // let datos:any= {productoId: localStorage.getItem('productoID')};
    // console.log(datos);
    this.conteosService.getTimeLineGraficaMedir().subscribe((data: backInter.timeLineGraficaCertificar) => {
      console.log("Timeline medir");
      console.log(data);
      // this.getFiltros();
      let datas:any[]=[];
      let i=0;
      let labelsFechas:any[]=[];
      let valorMayor: any[]=[];
      let labelsFechasLine:any[]=[];
      let valorMayorLine: any[]=[];
      data.resultado.forEach(element => {
        let objeto={x:0, y:0,r:0};
        objeto.x=i;
        objeto.y=element.endUsers;
        objeto.r=6;
        datas.push(objeto);
        labelsFechas.push(element.fecha);
        valorMayor.push(element.endUsers);
        i++;
      });

      data.resultado.forEach(element => {
        labelsFechasLine.push(this.datePipe.transform(new Date(element.fecha),'d MMM y','+0000',this.idiomaActual));
        valorMayorLine.push(element.endUsers);

        i++;
      });
      this.lineChartData[0].data=valorMayorLine;
      this.lineChartLabels=labelsFechasLine;
      console.log(this.lineChartData);
      this.graficaValoresLine(labelsFechasLine);

      this.graficaValores(labelsFechas,valorMayor,labelsFechas.length);
      this.bubbleChartData[0].data = datas;
      console.log(this.bubbleChartData);
      this.datosEncontrados=true;
      this.timeLineGraficaCer = data;
      // console.log(this.timeLineGraficaCer);

      // this.cargandoFiltros=false;
    }, error => {
      console.log("Error grafica timeline");
      console.log(error);
    });



  }

  timeLinePulse(){
    // let datos:any= {productoId: localStorage.getItem('productoID')};
    // console.log(datos);
    this.conteosService.getTimeLineGraficaPulse().subscribe((data: backInter.timeLineGraficaCertificar) => {
      console.log("Timeline medir");
      console.log(data);
      // this.getFiltros();
      let datas:any[]=[];
      let i=0;
      let labelsFechas:any[]=[];
      let valorMayor: any[]=[];
      let labelsFechasLine:any[]=[];
      let valorMayorLine: any[]=[];
      data.resultado.forEach(element => {
        let objeto={x:0, y:0,r:0};
        objeto.x=i;
        objeto.y=element.endUsers;
        objeto.r=6;
        datas.push(objeto);
        labelsFechas.push(element.fecha);
        valorMayor.push(element.endUsers);
        i++;
      });


      data.resultado.forEach(element => {
        labelsFechasLine.push(this.datePipe.transform(new Date(element.fecha),'d MMM y','+0000',this.idiomaActual));
        valorMayorLine.push(element.endUsers);

        i++;
      });
      this.lineChartData[0].data=valorMayorLine;
      this.lineChartLabels=labelsFechasLine;
      console.log(this.lineChartData);
      this.graficaValoresLine(labelsFechasLine);


      this.graficaValores(labelsFechas,valorMayor,labelsFechas.length);
      this.bubbleChartData[0].data = datas;
      console.log(this.bubbleChartData);
      this.datosEncontrados=true;
      this.timeLineGraficaCer = data;
      // console.log(this.timeLineGraficaCer);

      // this.cargandoFiltros=false;
    }, error => {
      console.log("Error grafica timeline");
      console.log(error);
    });



  }

  timeLineNorma35(){
    // let arreglomuestra= [1,2,3,4,5,6,7];
    // Math.max.apply(null, arreglomuestra);
    // console.log(Math.max.apply(null, arreglomuestra));
    // let respuesta:number =Math.max.apply(null, arreglomuestra)
    // console.log(respuesta);
    let banderaid:boolean;
     if(localStorage.getItem('Surveystaus_portal')== "activo"){
       banderaid=true;
     }
    let datos:any= {tipoEncuesta: localStorage.getItem('surveytype')};
    this.conteosService.getTimeLineGraficaNorma35(datos,banderaid).subscribe((data: any) => {
      let datas:any[]=[];
      let i=0;
      let labelsFechas:any[]=[];
      let valorMayor: any[]=[];
      let labelsFechasLine:any[]=[];
      let valorMayorLine: any[]=[];
      data.resultado.forEach(element => {
        let objeto={x:0, y:0,r:0};
        objeto.x=i;
        objeto.y=element.endUsers;
        objeto.r=6;
        datas.push(objeto);
        labelsFechas.push(element.fecha);
        valorMayor.push(element.endUsers);
        // console.log(valorMayorNorma);
        // console.log(this.valorMayor);
        i++;
      });
      let dateTranfor=[];
      data.resultado.forEach(element => {
        dateTranfor.push({fecha:new Date(element.fecha),endUsers:element.endUsers});
      });
      console.log('dateTranfor',dateTranfor);
      dateTranfor.sort( (a,b) => {
        if(a.fecha > b.fecha){ return 1; } else{ return -1; }
      });

      console.log('dateTranfor',dateTranfor);
      setTimeout(() => {
        dateTranfor.forEach(element => {
          labelsFechasLine.push(this.datePipe.transform(new Date(element.fecha),'d MMM y',this.offsetPipe,this.idiomaActual));
          valorMayorLine.push(element.endUsers);

          i++;
        });
      }, 1000);
      this.lineChartData[0].data=valorMayorLine;
      this.lineChartLabels=labelsFechasLine;
      console.log(this.lineChartData);
      this.graficaValoresLine(labelsFechasLine);

      this.graficaValores(labelsFechas,valorMayor,labelsFechas.length);
      console.log(labelsFechas.length);
      this.bubbleChartData[0].data = datas;
      console.log(this.bubbleChartData);
      this.datosEncontrados=true;
      this.timeLineGraficaCer = data;
      console.log(this.timeLineGraficaCer);

      // this.cargandoFiltros=false;
    }, error => {
      console.log(error);
      console.log("error getTimeLineGraficaNorma35");
    });
  }

  timeLineFocusArea(){

    this.conteosService.getTimeLineGraficaFocusArea().subscribe((data: backInter.timeLineGraficaCertificar) => {
      console.log("Respuesta del timeline");
      console.log(data);

      let datas:any[]=[];
      let i=0;
      let labelsFechas:any[]=[];
      let valorMayor: any[]=[];
      let labelsFechasLine:any[]=[];
      let valorMayorLine: any[]=[];
      data.resultado.forEach(element => {
        let objeto={x:0, y:0,r:0};
        objeto.x=i;
        objeto.y=element.endUsers;
        objeto.r=6;
        datas.push(objeto);
        labelsFechas.push(element.fecha);
        valorMayor.push(element.endUsers);

        i++;
      });


      data.resultado.forEach(element => {
        labelsFechasLine.push(this.datePipe.transform(new Date(element.fecha),'d MMM y','+0000',this.idiomaActual));
        valorMayorLine.push(element.endUsers);

        i++;
      });
      this.lineChartData[0].data=valorMayorLine;
      this.lineChartLabels=labelsFechasLine;
      console.log(this.lineChartData);
      this.graficaValoresLine(labelsFechasLine);

      this.graficaValores(labelsFechas,valorMayor,labelsFechas.length);
      this.bubbleChartData[0].data = datas;
      console.log(this.bubbleChartData);
      this.datosEncontrados=true;
      this.timeLineGraficaCer = data;
      console.log(this.timeLineGraficaCer);

      // this.cargandoFiltros=false;
    }, error => {
      console.log(error);
      console.log("error getTimeLineGraficaFocusArea");
    });



  }


  graficaValores(labelsFechas:any[],valorMayor:any[], maximoX: number){


    this.bubbleChartOptions = {
      responsive: true,
      legend: {
   display: false,
 },
      tooltips: {
         callbacks: {
            label: function(t, d) {
               return  labelsFechas[t.xLabel] + ', Total:' + t.yLabel + '';
            }
         }
      },

      scales: {
        xAxes: [
          {
            ticks: {
              min: 0,
              max: maximoX,
              stepSize: 1,


              callback: function(value, index, values) {
            // console.log(value+', '+index+',' +values);
               return labelsFechas[index];
              }

            }
          }
        ],
        yAxes: [
          {
            ticks: {
              min: 0,

              max: Math.max.apply(null, valorMayor)+(Math.max.apply(null, valorMayor)*.1),

              // console.log(Math.max(valorMayor))
            }
          }
        ]
      }
    };
  }

  graficaValoresLine(labelsFechasLine:any[]){
    this.lineChartOptions= {
        responsive: true,
        legend: {
     display: false,
   },
   tooltips: {
      callbacks: {
         label: function(t, d) {
            return 'Total:' + t.yLabel + '';
         }
      }
   },
        scales: {
          // We use this empty structure as a placeholder for dynamic theming.
          xAxes: [{}],
          yAxes: [
            // {
            //   id: 'y-axis-0',
            //   position: 'left',
            // },
            // {
            //   id: 'y-axis-1',
            //   position: 'right',
            //   gridLines: {
            //     // color: 'rgba(255,0,0,0.3)',
            //   },
            //   ticks: {
            //     // fontColor: 'red',
            //   }
            // }
          ]
        },
      };


  }

muestraDemoGra(event:MatCheckboxChange,itemv2:any){
  console.log('checked',event.checked);
  let indiceDemogra= this.catalogoFiltrosReducido.findIndex(item => item.nombrefiltro == itemv2.nombrefiltro);
  if (indiceDemogra!=-1) {
    console.log('lo encontro');
    this.catalogoFiltrosReducido[indiceDemogra].visible=event['checked'];
    this.catalogoFiltrosReducido=this.catalogoFiltrosReducido;
  }

}


infoExcel(){
  Swal.fire({
    title: this.mensajesTraducirTS.excel,
    didOpen: () => {
      Swal.showLoading()
    }
  });

  var wb = XLSX.utils.book_new();
  wb.Props = {
    Title: this.mensajesTraducirTS.titulo,
    Subject: this.mensajesTraducirTS.asunto,
    Author: this.mensajesTraducirTS.autor,
    CreatedDate: new Date()
  };
  wb.SheetNames.push(this.mensajesTraducirTS.hoja);
  // var ws_data = [['hello' , 'world']];  //a row with 2 columns
  var moment = require('moment');
  var ws_data = [
    [this.mensajesTraducirTS.nomempre,this.nombreEmpresaFinal],
    [this.mensajesTraducirTS.nomusuario,this.usuarioEmpresaFinal],
    [this.mensajesTraducirTS.nomprod,this.tipoProductoFinal+" "+this.fechaProducto],
    [this.mensajesTraducirTS.fechlanza,this.fechaLanzamiento],
    [this.mensajesTraducirTS.fechdesca,moment().format('l')],
    [this.mensajesTraducirTS.drestan,this.diasRestantes],
    [this.mensajesTraducirTS.totalcola,this.mensajesTraducirTS.totalfal,this.mensajesTraducirTS.totalcont,this.mensajesTraducirTS.totalpro,this.mensajesTraducirTS.reporte,this.mensajesTraducirTS.ranking],
    [this.totalUsers,this.totalUsers-this.endUsers,this.endUsers,this.porcentajeUsers+"%",this.totalUsers*85/100,this.resultadoRanking+"%" ]

  ];
  var ws = XLSX.utils.aoa_to_sheet(ws_data);
  XLSX.utils.book_append_sheet(wb, ws, this.mensajesTraducirTS.infogene);
  let idapoyo= localStorage.getItem('productoID');
  console.log("Producto ID");
  console.log(idapoyo);
  let data={productoId: localStorage.getItem('productoID')}
  let infoFocus={encuestaId: localStorage.getItem('encuestaID')}
  switch (this.tipoProducto) {
    case '1':
    this.conteosService.getInfoDescargaExcelCertificar(data).subscribe((data: backInter.getFullInfoExcel) => {
      console.log(data);
      if(data.success && data.array.length > 0){
        data.array.forEach( (nombre) =>{
          let hoja= [];
          let texto='PORTAL.EXCEL.FILTROSNAME.';
          this.translateSrv.get(texto+nombre.key).subscribe((res: string) => { texto = res; });
          hoja.push([
            this.mensajesTraducirTS.nomfilt,texto
          ]);
          hoja.push([
            this.mensajesTraducirTS.nomfilt,this.mensajesTraducirTS.totalcola,this.mensajesTraducirTS.totalfal,this.mensajesTraducirTS.totalcont,this.mensajesTraducirTS.totalpro

          ]);
          nombre.filtros.forEach(filtro => {
          let fila=[
            filtro.subfiltro,
            filtro.totalUsers,
            (filtro.totalUsers-filtro.endUsers),
            filtro.endUsers,
            filtro.porcentaje+"%",

          ]
          hoja.push(fila);
          });
          var ws = XLSX.utils.aoa_to_sheet(hoja);
         XLSX.utils.book_append_sheet(wb, ws, texto);
        });



           //  var ws = XLSX.utils.aoa_to_sheet(hoja);
           //  // wb.Sheets[this.mensajesTraducirTS.hoja] = ws;
           // XLSX.utils.book_append_sheet(wb, ws, nombre.key);
           // XLSX.utils.book_append_sheet(wb, ws, "sa");
           // XLSX.utils.book_append_sheet(wb, ws, "shsashdsk");
           // XLSX.utils.book_append_sheet(wb, ws, "shshzsdsk");
            var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

            var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
            var view = new Uint8Array(buf);  //create uint8array as viewer
            for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

            saveAs(new Blob([buf],{type:"application/octet-stream"}), this.mensajesTraducirTS.titulo+" "+this.nombreEmpresaFinal+'.xlsx');
            Swal.close();
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Descarga Correctamente',
              showConfirmButton: false,
              timer: 1500
            })
  }
       }, error => {
    console.log(error);
    });
   break;
   case 'c1': case 'c2': case 'c3': case 'p1': case 'm7': case 'f1': case 'am1': case 'td1': case 'pe1':
   this.conteosService.getInfoDescargaExcelCertificar(data).subscribe((data: backInter.getFullInfoExcel) => {
     console.log(data);
     if(data.success && data.array.length > 0){
       data.array.forEach( (nombre) =>{
         let hoja= [];
         let texto='PORTAL.EXCEL.FILTROSNAME.';
         this.translateSrv.get(texto+nombre.key).subscribe((res: string) => { texto = res; });
         hoja.push([
           this.mensajesTraducirTS.nomfilt,texto
         ]);
         hoja.push([
           this.mensajesTraducirTS.nomfilt,this.mensajesTraducirTS.totalcola,this.mensajesTraducirTS.totalfal,this.mensajesTraducirTS.totalcont,this.mensajesTraducirTS.totalpro

         ]);
         nombre.filtros.forEach(filtro => {
         let fila=[
           filtro.subfiltro,
           filtro.totalUsers,
           (filtro.totalUsers-filtro.endUsers),
           filtro.endUsers,
           filtro.porcentaje+"%",

         ]
         hoja.push(fila);
         });
         var ws = XLSX.utils.aoa_to_sheet(hoja);
        XLSX.utils.book_append_sheet(wb, ws, texto);
       });



          //  var ws = XLSX.utils.aoa_to_sheet(hoja);
          //  // wb.Sheets[this.mensajesTraducirTS.hoja] = ws;
          // XLSX.utils.book_append_sheet(wb, ws, nombre.key);
          // XLSX.utils.book_append_sheet(wb, ws, "sa");
          // XLSX.utils.book_append_sheet(wb, ws, "shsashdsk");
          // XLSX.utils.book_append_sheet(wb, ws, "shshzsdsk");
           var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

           var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
           var view = new Uint8Array(buf);  //create uint8array as viewer
           for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

           saveAs(new Blob([buf],{type:"application/octet-stream"}), this.mensajesTraducirTS.titulo+" "+this.nombreEmpresaFinal+'.xlsx');
           Swal.close();
           Swal.fire({
             position: 'center',
             icon: 'success',
             title: 'Descarga Correctamente',
             showConfirmButton: false,
             timer: 1500
           })
 }
      }, error => {
   console.log(error);
   });
  break;
   case '2':
   this.conteosService.getInfoDescargaExcelMedir(data).subscribe((data: backInter.getFullInfoExcel) => {
     console.log(data);
     if(data.success && data.array.length > 0){
       data.array.forEach( (nombre) =>{
         let hoja= [];
         let texto='PORTAL.EXCEL.FILTROSNAME.';
         this.translateSrv.get(texto+nombre.key).subscribe((res: string) => { texto = res; });
         hoja.push([
           this.mensajesTraducirTS.nomfilt,texto
         ]);
         hoja.push([
           this.mensajesTraducirTS.nomfilt,this.mensajesTraducirTS.totalcola,this.mensajesTraducirTS.totalfal,this.mensajesTraducirTS.totalcont,this.mensajesTraducirTS.totalpro

         ]);
         nombre.filtros.forEach(filtro => {
         let fila=[
           filtro.subfiltro,
           filtro.totalUsers,
           (filtro.totalUsers-filtro.endUsers),
           filtro.endUsers,
           filtro.porcentaje+"%",

         ]
         hoja.push(fila);
         });
         var ws = XLSX.utils.aoa_to_sheet(hoja);
        XLSX.utils.book_append_sheet(wb, ws, texto);
       });



          //  var ws = XLSX.utils.aoa_to_sheet(hoja);
          //  // wb.Sheets[this.mensajesTraducirTS.hoja] = ws;
          // XLSX.utils.book_append_sheet(wb, ws, nombre.key);
          // XLSX.utils.book_append_sheet(wb, ws, "sa");
          // XLSX.utils.book_append_sheet(wb, ws, "shsashdsk");
          // XLSX.utils.book_append_sheet(wb, ws, "shshzsdsk");
           var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

           var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
           var view = new Uint8Array(buf);  //create uint8array as viewer
           for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

           saveAs(new Blob([buf],{type:"application/octet-stream"}), this.mensajesTraducirTS.titulo+" "+this.nombreEmpresaFinal+'.xlsx');
           Swal.close();
           Swal.fire({
             position: 'center',
             icon: 'success',
             title: 'Descarga Correctamente',
             showConfirmButton: false,
             timer: 1500
           })
 }
      }, error => {
   console.log(error);
   });
  break;
  case '3':
  this.conteosService.getInfoDescargaExcePulse(data).subscribe((data: backInter.getFullInfoExcel) => {
    console.log(data);
    if(data.success && data.array.length > 0){
      data.array.forEach( (nombre) =>{
        let hoja= [];
        let texto='PORTAL.EXCEL.FILTROSNAME.';
        this.translateSrv.get(texto+nombre.key).subscribe((res: string) => { texto = res; });
        hoja.push([
          this.mensajesTraducirTS.nomfilt,texto
        ]);
        hoja.push([
          this.mensajesTraducirTS.nomfilt,this.mensajesTraducirTS.totalcola,this.mensajesTraducirTS.totalfal,this.mensajesTraducirTS.totalcont,this.mensajesTraducirTS.totalpro

        ]);
        nombre.filtros.forEach(filtro => {
        let fila=[
          filtro.subfiltro,
          filtro.totalUsers,
          (filtro.totalUsers-filtro.endUsers),
          filtro.endUsers,
          filtro.porcentaje+"%",

        ]
        hoja.push(fila);
        });
        var ws = XLSX.utils.aoa_to_sheet(hoja);
       XLSX.utils.book_append_sheet(wb, ws, texto);
      });



         //  var ws = XLSX.utils.aoa_to_sheet(hoja);
         //  // wb.Sheets[this.mensajesTraducirTS.hoja] = ws;
         // XLSX.utils.book_append_sheet(wb, ws, nombre.key);
         // XLSX.utils.book_append_sheet(wb, ws, "sa");
         // XLSX.utils.book_append_sheet(wb, ws, "shsashdsk");
         // XLSX.utils.book_append_sheet(wb, ws, "shshzsdsk");
          var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

          var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
          var view = new Uint8Array(buf);  //create uint8array as viewer
          for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

          saveAs(new Blob([buf],{type:"application/octet-stream"}), this.mensajesTraducirTS.titulo+" "+this.nombreEmpresaFinal+'.xlsx');
          Swal.close();
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Descarga Correctamente',
            showConfirmButton: false,
            timer: 1500
          })
}
     }, error => {
  console.log(error);
  });
 break;
  case '4':
  console.log(infoFocus);

  this.conteosService.getInfoDescargaExceFocusArea(infoFocus).subscribe((data: backInter.getFullInfoExcel) => {
    console.log(data);
    if(data.success && data.array.length > 0){
      data.array.forEach( (nombre) =>{
        let hoja= [];
        let texto='PORTAL.EXCEL.FILTROSNAME.';
        this.translateSrv.get(texto+nombre.key).subscribe((res: string) => { texto = res; });
        hoja.push([
          this.mensajesTraducirTS.nomfilt,texto
        ]);
        hoja.push([
          this.mensajesTraducirTS.nomfilt,this.mensajesTraducirTS.totalcola,this.mensajesTraducirTS.totalfal,this.mensajesTraducirTS.totalcont,this.mensajesTraducirTS.totalpro

        ]);
        nombre.filtros.forEach(filtro => {
        let fila=[
          filtro.subfiltro,
          filtro.totalUsers,
          (filtro.totalUsers-filtro.endUsers),
          filtro.endUsers,
          filtro.porcentaje+"%",

        ]
        hoja.push(fila);
        });
        var ws = XLSX.utils.aoa_to_sheet(hoja);
       XLSX.utils.book_append_sheet(wb, ws, texto);
      });



         //  var ws = XLSX.utils.aoa_to_sheet(hoja);
         //  // wb.Sheets[this.mensajesTraducirTS.hoja] = ws;
         // XLSX.utils.book_append_sheet(wb, ws, nombre.key);
         // XLSX.utils.book_append_sheet(wb, ws, "sa");
         // XLSX.utils.book_append_sheet(wb, ws, "shsashdsk");
         // XLSX.utils.book_append_sheet(wb, ws, "shshzsdsk");
          var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

          var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
          var view = new Uint8Array(buf);  //create uint8array as viewer
          for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

          saveAs(new Blob([buf],{type:"application/octet-stream"}), this.mensajesTraducirTS.titulo+" "+this.nombreEmpresaFinal+'.xlsx');
          Swal.close();
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Descarga Correctamente',
            showConfirmButton: false,
            timer: 1500
          })
}
     }, error => {
  console.log(error);
  });
 break;
 case 'm1': case "m2": case "m3": case "m4": case "m5": case "m6":
 this.conteosService.getInfoDescargaExcelMedir(data).subscribe((data: backInter.getFullInfoExcel) => {
   console.log(data);
   if(data.success && data.array.length > 0){
     data.array.forEach( (nombre) =>{
       let hoja= [];
       let texto='PORTAL.EXCEL.FILTROSNAME.';
       this.translateSrv.get(texto+nombre.key).subscribe((res: string) => { texto = res; });
       hoja.push([
         this.mensajesTraducirTS.nomfilt,texto
       ]);
       hoja.push([
         this.mensajesTraducirTS.nomfilt,this.mensajesTraducirTS.totalcola,this.mensajesTraducirTS.totalfal,this.mensajesTraducirTS.totalcont,this.mensajesTraducirTS.totalpro

       ]);
       nombre.filtros.forEach(filtro => {
       let fila=[
         filtro.subfiltro,
         filtro.totalUsers,
         (filtro.totalUsers-filtro.endUsers),
         filtro.endUsers,
         filtro.porcentaje+"%",

       ]
       hoja.push(fila);
       });
       var ws = XLSX.utils.aoa_to_sheet(hoja);
      XLSX.utils.book_append_sheet(wb, ws, texto);
     });



        //  var ws = XLSX.utils.aoa_to_sheet(hoja);
        //  // wb.Sheets[this.mensajesTraducirTS.hoja] = ws;
        // XLSX.utils.book_append_sheet(wb, ws, nombre.key);
        // XLSX.utils.book_append_sheet(wb, ws, "sa");
        // XLSX.utils.book_append_sheet(wb, ws, "shsashdsk");
        // XLSX.utils.book_append_sheet(wb, ws, "shshzsdsk");
         var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

         var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
         var view = new Uint8Array(buf);  //create uint8array as viewer
         for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

         saveAs(new Blob([buf],{type:"application/octet-stream"}), this.mensajesTraducirTS.titulo+" "+this.nombreEmpresaFinal+'.xlsx');
         Swal.close();
         Swal.fire({
           position: 'center',
           icon: 'success',
           title: 'Descarga Correctamente',
           showConfirmButton: false,
           timer: 1500
         })
}
    }, error => {
 console.log(error);
 });
break;
    default:
      break;
  }


}

openDialog(idsurvey?): void {
  let dataModal: any;
  //this.emitEventToChild2();
  const dialogRef = this.dialog.open(Surveyuser, {
    width: '90%', height: '65%',
    data: {
      SurveyId: '',
      surveyKey: '',
      idEmpresa: '',
      idProducto: localStorage.getItem('productoID')
    }

  });
  dialogRef.afterClosed().subscribe(result => {
    // Actualizar doctores
    /*let dataIdarch = {
      seccionId: idSeccion,
      fechaDocumentador: this.fechaCertificar
    }
    if(idSeccion){
      this.actualizarTareas(dataIdarch);
    } */
  });

}

statusMostrarResuCerti(insti){
  this.encuestaService.estatusMostrarCajasCerPortal(localStorage.getItem('companyID'),localStorage.getItem('productoID')).subscribe((respuesta:any) => {
    console.log("statusMostrarResuCerti:",respuesta);
    console.log('this.instituto',insti);

    if (insti=='MX' && !respuesta.resultsBoxEntregables && !respuesta.resultsBoxRanking || this.cajasCerPortaSurveyStatus==1&&!respuesta.resultsBoxEntregables && !respuesta.resultsBoxRanking ) {
      console.log('entro 1',insti);
      this.resultsBoxRanking=true;
      this.resultsBoxEntregables=true;
    }else if(insti=='CAyC' && !respuesta.resultsBoxEntregables && !respuesta.resultsBoxRanking){
      this.resultsBoxRanking=true;
      this.resultsBoxEntregables=false;
    }else{
      console.log('entro 2',insti);
      this.resultsBoxRanking=respuesta.resultsBoxRanking;
      this.resultsBoxEntregables=respuesta.resultsBoxEntregables;

    }
    switch (insti) {
      case 'CAyC':
      switch (this.tipoProducto) {
        case 'm7':
        this.textResultsBoxEntregables='PORTAL.REPORTE_MED_CARCA';
        this.textResultsBoxRanking='PORTAL.RANKING_MED_CARCA';

        this.textToolResultsBoxEntregables='PORTAL.TOOLT_REPORTE_MED_CARCA';
        this.textToolResultsBoxRanking='PORTAL.TOOLT_RANKING_MED_CARCA';

          break;

        default:
        this.textResultsBoxEntregables='PORTAL.REPORTE_CER_CARCA';
        this.textResultsBoxRanking='PORTAL.RANKING_CER_CARCA';

        this.textToolResultsBoxEntregables='PORTAL.TOOLT_REPORTE_CER_CARCA';
        this.textToolResultsBoxRanking='PORTAL.TOOLT_RANKING_CER_CARCA';
          break;
      }

        break;

      default:
      this.textResultsBoxEntregables='PORTAL.REPORTE';
      this.textResultsBoxRanking='PORTAL.RANKING';

      this.textToolResultsBoxEntregables='PORTAL.TOOLT_REPORTE';
      this.textToolResultsBoxRanking='PORTAL.TOOLT_RANKING';
        break;
    }
  });
}

getProrrogasFechaCierre(datos){
  this.conteosService.getProrrogasFechaCierre(datos).subscribe( (data: any) => {
    console.log("getProrrogasFechaCierre:",data);
    if(data.result.length > 0){
this.resultGetProrrogasFechaCierre=data.result;
  let fechaLanzamiento1= moment();
  let fechaLanzamientoProrroga= moment(this.resultGetProrrogasFechaCierre[0].fecha);
  let fechaLanzamientoEncuesta= moment(this.fechaLanzamiento);
if(fechaLanzamiento1.isAfter(fechaLanzamientoProrroga)){
  this.diasRestantes=0;
  this.progreso=100;
}
else{
  let totalDias= fechaLanzamientoProrroga.diff(fechaLanzamientoEncuesta,'days');
  console.log('totalDias',totalDias);

  this.diasRestantes=fechaLanzamientoProrroga.diff(fechaLanzamiento1,'days');
  console.log("Dias restantes",this.diasRestantes);
  // let transcurridos= fechaLanzamientoEncuesta.diff(fechaLanzamiento1,'days');
  this.diasTranscurridos= fechaLanzamientoEncuesta.diff(fechaLanzamiento1,'days');
  console.log("Dias trancurridos",this.diasTranscurridos);
  this.progreso= (100/totalDias)*(totalDias-this.diasRestantes);
  console.log(this.progreso);
  console.log(fechaLanzamiento1.diff(fechaLanzamientoProrroga,'days'));
}
  this.cambiaColorProgress();
    }else{
    }
  });
}




}

@Component({
  selector: 'Surveyuser',
  templateUrl: './usersSurvey.dialog.component.html',
  styleUrls: ['./portal-conteos.component.scss'],

})


export class Surveyuser {

  //private _unsubscribeAll: Subject<any>;
  informacion:any;
  cargandoCitas:boolean=true;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  constructor(
    private _formBuilder: FormBuilder,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    public authService: AuthService,
    private surveyServ: SurveyService,
    public dialogRef: MatDialogRef<Surveyuser>,
    private cierreService: CierreService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.obtieneCertificarActual();
    this.informacion=data;
    console.log(this.informacion);
    this.getUsuarios(this.informacion.idProducto,1);
    lang_avances.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    //this.avanceSurvey(this.informacion.SurveyId,this.informacion.surveyKey,this.informacion.idEmpresa);
    //this.getImagenLogo(this.informacion.idEmpresa);
    //this.datosEmpresa(this.informacion.idEmpresa);
   }
   ngOnInit() {

  }
  nombresColumnasheader = ['name','email','surveyid','acc1'];
  nombresColumnasCont = ['name','email','surveyid','acc1'];
  resultadosUsuario:any [] = [];
  busqueda: string = "";
  paginaActual: number;
  totalEmpresas: number;
  nextPag: number;
  prevPag: number;
  contadorInicio: number;
  contadorFin: number;
  idProducto_tmp:any;
  dataSource: MatTableDataSource<resultado>;
  cargando:boolean=false;
  getUsuarios(idProducto?,pagina?){
    this.idProducto_tmp=idProducto;
    this.surveyServ.getUsuarios(idProducto,pagina).subscribe( (data: backInter.surveyCheck) => {
      if(data.success){
        console.log(data);
        this.resultadosUsuario=data.result.docs;
        this.totalEmpresas = data.result.totalDocs;
        this.nextPag = data.result.nextPage;
        this.prevPag = data.result.prevPage;
        this.contadorInicio = data.result.pagingCounter;
        this.contadorFin = this.contadorInicio + (data.result.limit - 1);
        if(this.contadorFin > this.totalEmpresas){
          this.contadorFin = this.totalEmpresas;
        }

        this.dataSource = new MatTableDataSource(this.resultadosUsuario); // Filtro
        this.dataSource.filterPredicate = (data, filterValue: string)  => {
          const accumulator = (currentTerm, key) => {
            return key === 'doctores' ? currentTerm : currentTerm + data[key];
          };
          const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
          // Transform the filterValue by converting it to lowercase and removing whitespace.
          const transformedFilter = filterValue.trim().toLowerCase();
          return dataStr.indexOf(transformedFilter) !== -1;
        };
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        //this.mostrarTabla=true;
        this.cargando=true;
      }

    });
  }
    name:any;
    fechaInicio:any;
    fechaFin:any;
    status:any;
    cargandoSurvey:boolean=false;

    verSeccion(){


    }

   avanceSurvey(surveyKey){
    this.surveyServ.getEstatus(this.idSurvey,surveyKey).subscribe( (data: any) => {
      console.log("Avance survey");
      console.log(data);
      this.name=data.fullName;
      if(data.fechaIn){
        let fechaAux=data.fechaIn.toString();
        this.fechaInicio=fechaAux.substr(0,10);
      }else{
        this.fechaInicio="N/A";
      }
      if(data.fechaFin){
        let fechaAux2=data.fechaFin.toString();
        this.fechaFin=fechaAux2.substr(0,10);
      }else{
        this.fechaFin="N/A";
      }

      switch (data.idStatus){
        case 1:
          this.status="AVANCES.TITULOS.ESTADOS_ENC.ESTADO1";
        break;
        case 2:
          this.status="AVANCES.TITULOS.ESTADOS_ENC.ESTADO2";
        break;
        case 3:
          this.status="AVANCES.TITULOS.ESTADOS_ENC.ESTADO3";
        break;
        case 4:
          this.status="AVANCES.TITULOS.ESTADOS_ENC.ESTADO4";
        break;
      }
      this.cargandoSurvey=true;
      this.secondSeccion=true;
    });
  }
  rutaimagen:any;
  nombreEmpresa:any;
  datosEmpresa(idEmpresa){
    this.surveyServ.getInfoEmpresa(idEmpresa).subscribe((data:backInter.infoEmpresa) => {
      if(data){
        let url = DATOS_API.url.split(":");
        this.rutaimagen= url[1]+"/surveyadministrator/backend/"+data.data.logoEmpresa;
        this.nombreEmpresa=data.data.nombreEmpresa;
      }
      console.log(data);
    }, error  => {
      console.log("error");
    });
  }

  search:string='';
  secondSeccion:boolean=false;
  getListaEmpresas(pagina?:number){
    this.secondSeccion=false;
    this.search='';
    if(this.busqueda.length > 0){
      this.search = this.busqueda
    }
    this.surveyServ.getUsuariosFilter(this.idProducto_tmp,pagina,this.search).subscribe( (data: backInter.surveyCheck) => {

      if(data.success){
        //console.log(data);
        this.resultadosUsuario=data.result.docs;
        this.totalEmpresas = data.result.totalDocs;
        this.nextPag = data.result.nextPage;
        this.prevPag = data.result.prevPage;
        this.contadorInicio = data.result.pagingCounter;
        this.contadorFin = this.contadorInicio + (data.result.limit - 1);
        if(this.contadorFin > this.totalEmpresas){
          this.contadorFin = this.totalEmpresas;
        }
        this.dataSource = new MatTableDataSource(this.resultadosUsuario); // Filtro
        this.dataSource.filterPredicate = (data, filterValue: string)  => {
          const accumulator = (currentTerm, key) => {
            return key === 'doctores' ? currentTerm : currentTerm + data[key];
          };
          const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
          // Transform the filterValue by converting it to lowercase and removing whitespace.
          const transformedFilter = filterValue.trim().toLowerCase();
          return dataStr.indexOf(transformedFilter) !== -1;
        };
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }
  productoCertificar: backInter.prodCert;
  productoId:any;
  idSurvey:any;
  obtieneCertificarActual(){
    this.cierreService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaCertificar;
            let idProducto = producto.idCertificar;
            this.productoCertificar = producto;
            this.productoId = this.productoCertificar.idCertificar;
            this.idSurvey = this.productoCertificar.idSurvey;
            console.log(this.productoCertificar.tokenConfig);

          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }




}
